(() => {
  const openers = document.querySelectorAll('[data-drawer-open]');
  const closers = document.querySelectorAll('[data-drawer-close]');
  const drawer = document.querySelector('[data-drawer]');

  const open = () => {
    document.body.classList.add('drawer-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  };

  const close = () => {
    document.body.classList.remove('drawer-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  };

  openers.forEach((button) => button.addEventListener('click', open));
  closers.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerItems = document.querySelector('[data-cart-drawer-items]');
  const cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
  const cartDrawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  const cartDrawerShipping = document.querySelector('[data-cart-drawer-shipping]');
  const cartOpeners = document.querySelectorAll('[data-cart-drawer-open]');
  const cartClosers = document.querySelectorAll('[data-cart-drawer-close]');
  const cartFallbackVariantId = document.body?.dataset.cartFallbackVariantId?.trim();
  const cartFallbackProductTitle = document.body?.dataset.cartFallbackProductTitle?.trim();
  const shopRoot = window.Shopify?.routes?.root || '/';

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'CAD';
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency
    }).format((Number(cents) || 0) / 100);
  };

  const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

  const openCartDrawer = () => {
    if (!cartDrawer) return;
    document.body.classList.add('cart-drawer-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  };

  const closeCartDrawer = () => {
    document.body.classList.remove('cart-drawer-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('.cart-icon').forEach((icon) => {
      if (count > 0 && !icon.querySelector('.cart-count')) {
        const badge = document.createElement('span');
        badge.className = 'cart-count';
        icon.appendChild(badge);
      }
    });
    document.querySelectorAll('.cart-count').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count < 1;
    });
  };

  const renderCartDrawer = (cart) => {
    if (!cartDrawerItems || !cartDrawerFooter) return;
    updateCartCount(cart.item_count || 0);
    if (!cart.items?.length) {
      cartDrawerItems.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
      cartDrawerFooter.hidden = true;
      return;
    }
    cartDrawerItems.innerHTML = cart.items.map((item, index) => {
      const customPreview = item.properties?.['Product Preview'];
      const displayImage = customPreview || item.image;
      const image = displayImage ? `<img src="${escapeHTML(displayImage)}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer-variant">${escapeHTML(item.variant_title)}</p>` : '';
      const properties = Object.entries(item.properties || {})
        .filter(([name, value]) => value && !String(name).startsWith('_') && !/Preview|Print File|Design Data/i.test(name))
        .map(([name, value]) => `<li><strong>${escapeHTML(name)}:</strong> ${escapeHTML(value)}</li>`)
        .join('');
      return `
        <article class="cart-drawer-item">
          <a href="${escapeHTML(item.url)}">${image}</a>
          <div>
            <a class="cart-drawer-title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
            ${variant}
            ${properties ? `<ul class="cart-drawer-properties">${properties}</ul>` : ''}
            <div class="cart-drawer-qty" aria-label="Quantity">
              <button type="button" data-cart-line="${index + 1}" data-cart-qty="${Math.max(0, item.quantity - 1)}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-line="${index + 1}" data-cart-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          <strong class="cart-drawer-price">${formatMoney(item.final_line_price)}</strong>
        </article>
      `;
    }).join('');
    cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
    if (cartDrawerShipping) {
      cartDrawerShipping.textContent = cart.item_count >= 2
        ? "You've unlocked free shipping!"
        : `Add ${2 - cart.item_count} more item for free shipping`;
    }
    cartDrawerFooter.hidden = false;
  };

  const fetchCart = async () => {
    const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart.');
    const cart = await response.json();
    renderCartDrawer(cart);
    return cart;
  };

  cartOpeners.forEach((opener) => {
    opener.addEventListener('click', async (event) => {
      event.preventDefault();
      openCartDrawer();
      try {
        await fetchCart();
      } catch {
        window.location.href = opener.getAttribute('href') || '/cart';
      }
    });
  });

  cartClosers.forEach((closer) => closer.addEventListener('click', closeCartDrawer));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCartDrawer();
  });

  cartDrawerItems?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-line]');
    if (!button) return;
    button.disabled = true;
    const line = Number(button.dataset.cartLine);
    const quantity = Number(button.dataset.cartQty);
    const response = await fetch(`${shopRoot}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (response.ok) renderCartDrawer(await response.json());
  });

  const closeInstagramModals = () => {
    document.querySelectorAll('.instagram-modal.is-open').forEach((modal) => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('instagram-modal-open');
  };

  document.querySelectorAll('[data-instagram-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const modal = document.getElementById(button.getAttribute('data-instagram-open'));
      if (!modal) return;
      closeInstagramModals();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('instagram-modal-open');
    });
  });

  document.querySelectorAll('[data-instagram-close]').forEach((button) => {
    button.addEventListener('click', closeInstagramModals);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeInstagramModals();
  });

  document.querySelectorAll('[data-personalized-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-slider-slide], .personalized-slide'));
    const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
    if (slides.length <= 1) return;
    const interval = Math.max(3000, Number.parseInt(slider.dataset.sliderInterval || '5200', 10) || 5200);
    let activeIndex = 0;
    let timer = null;
    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    };
    const start = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        start();
      });
    });
    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', start);
    start();
  });

  document.querySelectorAll('[data-main-product-form]').forEach((form) => {
    const variantInput = form.querySelector('[data-variant-id]');
    const variantsJson = form.querySelector('[data-product-variants-json]');
    const optionNamesJson = form.querySelector('[data-product-option-names]');
    const addButton = form.querySelector('.product-atc[type="submit"]');
    const addButtonLabel = addButton?.querySelector('span');
    const stockMessage = form.querySelector('[data-variant-stock-message]');
    const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    const optionGroups = Array.from(form.querySelectorAll('[data-variant-option-group]'));
    const propertyGroups = Array.from(form.querySelectorAll('[data-line-item-property-group]'));
    const quantityInput = form.querySelector('[data-quantity-input]');
    const quantityMinus = form.querySelector('[data-quantity-minus]');
    const quantityPlus = form.querySelector('[data-quantity-plus]');
    const productTemplate = form.closest('.product-template');
    const currentPrice = productTemplate?.querySelector('[data-current-price]');
    const comparePrice = productTemplate?.querySelector('[data-compare-price]');
    const mockupMap = productTemplate?.querySelector('[data-custom-mockup-map]');
    const defaultMockupSrc = mockupMap?.dataset.defaultMockupSrc || '';
    const customMockups = Array.from(mockupMap?.querySelectorAll('[data-custom-mockup-entry]') || []).map((entry) => ({
      mediaId: entry.dataset.customMockupMediaId || '',
      color: entry.dataset.customMockupColor || '',
      src: entry.dataset.customMockupSrc || ''
    })).filter((entry) => entry.src);

    if (!variantInput || !variantsJson) return;

    let productVariants = [];
    let productOptionNames = [];

    try {
      productVariants = JSON.parse(variantsJson.textContent || '[]');
    } catch (error) {
      console.error('ANDUVU variant data error:', error);
    }

    try {
      productOptionNames = JSON.parse(optionNamesJson?.textContent || '[]');
    } catch (error) {
      console.error('ANDUVU option-name data error:', error);
    }

    const normalizeOption = (value) => String(value ?? '').trim().toLowerCase();
    const normalizeOptionName = (value) => normalizeOption(value)
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const normalizeColorKey = (value) => normalizeOption(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/grey/g, 'gray')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const colorMockupFor = (value) => {
      const colorKey = normalizeColorKey(value);
      if (!colorKey) return '';
      const exact = customMockups.find((entry) => normalizeColorKey(entry.color) === colorKey);
      if (exact) return exact.src;
      const compatible = customMockups.find((entry) => {
        const entryKey = normalizeColorKey(entry.color);
        return entryKey.startsWith(`${colorKey}-`) || colorKey.startsWith(`${entryKey}-`);
      });
      return compatible?.src || '';
    };

    const variantMockupFor = (mediaId, imageSrc) => {
      const id = String(mediaId || '');
      const exactMedia = id ? customMockups.find((entry) => entry.mediaId === id) : null;
      if (exactMedia) return exactMedia.src;
      const src = String(imageSrc || '');
      return customMockups.find((entry) => entry.src === src)?.src || '';
    };

    const syncDesignerMockup = (src, selectedColor) => {
      if (!src) return;
      const designerSection = productTemplate?.querySelector('[data-product-inline-designer] [data-product-designer]');
      if (!designerSection) return;
      designerSection.dataset.activeMockupSrc = src;
      const productOption = designerSection.querySelector('[data-custom-product-select] option:checked');
      if (productOption) productOption.dataset.productImage = src;
      const colorSelect = designerSection.querySelector('[data-designer-shirt-color]');
      const matchingColor = Array.from(colorSelect?.options || []).find((option) => (
        normalizeColorKey(option.value) === normalizeColorKey(selectedColor)
      ));
      if (colorSelect && matchingColor && colorSelect.value !== matchingColor.value) {
        colorSelect.value = matchingColor.value;
        colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (typeof designerSection._anduvuSetMockup === 'function') {
        designerSection._anduvuSetMockup(src, {
          render: productTemplate?.classList.contains('is-customizing-product') === true
        });
        return;
      }
      const designerImage = designerSection.querySelector('[data-designer-product-image]');
      if (designerImage) {
        designerImage.src = src;
        designerImage.srcset = '';
      }
    };

    const canonicalOptionName = (value) => {
      const name = normalizeOptionName(value);
      if (name === 'colour' || name.includes('color') || name.includes('colour')) return 'color';
      if (name === 'size' || name.includes('size')) return 'size';
      if (
        name === 'print location' ||
        name === 'print position' ||
        name === 'placement' ||
        (name.includes('print') && (name.includes('location') || name.includes('position')))
      ) return 'print-location';
      return name;
    };

    const getVariantOptions = (variant) => {
      if (Array.isArray(variant?.options)) return variant.options;
      return [variant?.option1, variant?.option2, variant?.option3].filter((value) => value != null);
    };

    const optionPositionByName = new Map();
    productOptionNames.forEach((name, index) => {
      optionPositionByName.set(canonicalOptionName(name), index);
    });

    optionGroups.forEach((group) => {
      const canonicalName = canonicalOptionName(group.dataset.optionName || '');
      const position = Math.max(0, Number.parseInt(group.dataset.optionPosition || '1', 10) - 1);
      if (canonicalName) optionPositionByName.set(canonicalName, position);
    });

    const selectedValueFromGroup = (canonicalName) => {
      const group = optionGroups.find((item) => (
        canonicalOptionName(item.dataset.optionName || '') === canonicalName
      ));
      return normalizeOption(group?.querySelector('input[type="radio"]:checked')?.value || '');
    };

    const selectedPrintLocation = () => normalizeOption(
      form.querySelector('input[name="properties[Print Location]"]:checked')?.value || ''
    );

    const getCriteriaFor = (names) => names
      .map((name) => {
        const value = name === 'print-location'
          ? selectedPrintLocation()
          : selectedValueFromGroup(name);
        const position = optionPositionByName.get(name);
        return { name, value, position };
      })
      .filter(({ value, position }) => value !== '' && Number.isInteger(position));

    const variantMatchesCriteria = (variant, criteria) => {
      const options = getVariantOptions(variant).map(normalizeOption);
      return criteria.every(({ position, value }) => options[position] === value);
    };

    const findMatches = (criteria, requiredCount) => {
      if (criteria.length !== requiredCount) return [];
      return productVariants.filter((variant) => variantMatchesCriteria(variant, criteria));
    };

    const firstMatchingVariant = (variants) => variants.find((variant) => Boolean(variant?.id)) || null;

    /*
      Variant fallback order for mixed Shopify catalogs:
      1. Color + Size + Print Location (legacy products where all 3 are variants)
      2. Color + Size
      3. Size only
      4. Exact match for whatever real Shopify option groups the product exposes
      5. The sole/default variant

      Print Location remains submitted as properties[Print Location]. It is only
      used for variant lookup when Shopify Admin actually has a Print Location
      option for that product.
    */
    const findSelectedVariant = () => {
      const attempts = [
        { criteria: getCriteriaFor(['color', 'size', 'print-location']), count: 3, mode: 'color-size-print' },
        { criteria: getCriteriaFor(['color', 'size']), count: 2, mode: 'color-size' },
        { criteria: getCriteriaFor(['size']), count: 1, mode: 'size' }
      ];

      let unavailableFallback = null;

      for (const attempt of attempts) {
        const matches = findMatches(attempt.criteria, attempt.count);
        const available = firstMatchingVariant(matches);
        if (available) return { variant: available, mode: attempt.mode };
        if (!unavailableFallback && matches[0]) {
          unavailableFallback = { variant: matches[0], mode: attempt.mode };
        }
      }

      const exactCriteria = optionGroups.map((group) => ({
        position: Math.max(0, Number.parseInt(group.dataset.optionPosition || '1', 10) - 1),
        value: normalizeOption(group.querySelector('input[type="radio"]:checked')?.value || '')
      })).filter(({ value }) => value !== '');

      if (exactCriteria.length) {
        const exactMatches = productVariants.filter((variant) => (
          variantMatchesCriteria(variant, exactCriteria)
        ));
        const exactAvailable = firstMatchingVariant(exactMatches);
        if (exactAvailable) return { variant: exactAvailable, mode: 'exact-options' };
        if (!unavailableFallback && exactMatches[0]) {
          unavailableFallback = { variant: exactMatches[0], mode: 'exact-options' };
        }
      }

      if (productVariants.length === 1 && productVariants[0]?.id) {
        return { variant: productVariants[0], mode: 'single-variant' };
      }

      return unavailableFallback || { variant: null, mode: 'none' };
    };

    const setMessage = (message = '', isError = false) => {
      if (!stockMessage) return;
      stockMessage.textContent = message;
      stockMessage.classList.toggle('is-sold-out', Boolean(isError));
      stockMessage.hidden = !message;
    };

    const syncSelectedPills = (groups) => {
      groups.forEach((group) => {
        group.querySelectorAll('.variant-pill').forEach((pill) => {
          pill.classList.toggle('is-selected', Boolean(pill.querySelector('input:checked')));
        });
      });
    };

    const setVariantInputValue = (id) => {
      const value = id ? String(id) : '';
      if (variantInput.tagName === 'SELECT') {
        const option = Array.from(variantInput.options).find((item) => item.value === value);
        if (option) {
          variantInput.value = value;
        } else if (!value) {
          variantInput.selectedIndex = -1;
        }
        return;
      }
      variantInput.value = value;
    };

    const updateProductMedia = () => {
      if (variantInput.tagName !== 'SELECT') return;
      const selectedOption = variantInput.options[variantInput.selectedIndex];
      const selectedColor = selectedValueFromGroup('color');
      const variantImageSrc = selectedOption?.dataset.variantImage || '';
      const variantMediaId = selectedOption?.dataset.variantMediaId || '';
      const variantMockupSrc = variantMockupFor(variantMediaId, variantImageSrc);
      const colorMockupSrc = colorMockupFor(selectedColor);
      const mockupSrc = variantMockupSrc || colorMockupSrc;
      const nextSrc = mockupSrc || variantImageSrc || defaultMockupSrc;
      const nextMediaId = mockupSrc || !variantImageSrc ? '' : variantMediaId;
      if (!nextSrc && !nextMediaId) return;

      const gallery = productTemplate?.querySelector('.product-template-gallery');
      const image = gallery?.querySelector('.product-main-image');
      if (image && nextSrc) {
        image.src = nextSrc;
        image.srcset = '';
      }
      if (nextSrc) syncDesignerMockup(nextSrc, selectedColor);
      const customToggle = gallery?.querySelector('[data-custom-mockup-toggle]');
      if (customToggle) {
        if (mockupSrc) customToggle.dataset.customMockupSrc = mockupSrc;
        customToggle.setAttribute('aria-pressed', 'false');
        customToggle.textContent = 'CUSTOM';
      }

      const thumbs = Array.from(gallery?.querySelectorAll('[data-product-thumb]') || []);
      if (!thumbs.length) return;
      if (mockupSrc) {
        thumbs.forEach((thumb) => thumb.classList.remove('is-active'));
        return;
      }
      const activeThumb = thumbs.find((thumb) => (
        (nextMediaId && thumb.dataset.mediaId === nextMediaId) ||
        (nextSrc && thumb.dataset.productThumb === nextSrc)
      ));
      if (activeThumb) {
        thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === activeThumb));
      }
    };

    const dispatchVariantChange = () => {
      variantInput.dispatchEvent(new Event('input', { bubbles: true }));
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const updateVariant = () => {
      syncSelectedPills(optionGroups);
      syncSelectedPills(propertyGroups);

      const result = findSelectedVariant();
      const variant = result.variant;
      const isAvailable = Boolean(variant?.id);

      setVariantInputValue(variant?.id);
      variantInput.dataset.matchMode = result.mode;
      if (variant && currentPrice) currentPrice.textContent = formatMoney(variant.price);
      if (comparePrice) {
        const manualComparePrice = Number(comparePrice.dataset.manualComparePrice || 0);
        const comparePriceValue = manualComparePrice > 0
          ? manualComparePrice
          : Number(variant?.compare_at_price || 0);
        const onSale = comparePriceValue > Number(variant?.price || 0);
        comparePrice.hidden = !onSale;
        comparePrice.textContent = onSale ? formatMoney(comparePriceValue) : '';
      }
      updateProductMedia();
      dispatchVariantChange();

      if (addButton) addButton.disabled = false;
      if (addButtonLabel) {
        addButtonLabel.textContent = 'Add to cart';
      }
      if (dynamicCheckout) dynamicCheckout.hidden = false;

      if (!variant) {
        setMessage('No matching Shopify variant was found for this selection.', true);
      } else {
        setMessage();
      }

      if (variant?.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    const normalizeQuantity = () => {
      if (!quantityInput) return 1;
      const value = Math.max(1, Number.parseInt(quantityInput.value || '1', 10) || 1);
      quantityInput.value = String(value);
      return value;
    };

    quantityMinus?.addEventListener('click', () => {
      const current = normalizeQuantity();
      if (quantityInput) quantityInput.value = String(Math.max(1, current - 1));
    });
    quantityPlus?.addEventListener('click', () => {
      const current = normalizeQuantity();
      if (quantityInput) quantityInput.value = String(current + 1);
    });
    quantityInput?.addEventListener('change', normalizeQuantity);
    quantityInput?.addEventListener('blur', normalizeQuantity);

    optionGroups.forEach((group) => {
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', updateVariant);
      });
    });

    propertyGroups.forEach((group) => {
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', updateVariant);
      });
    });

    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      const isThemeCartButton = submitter?.classList.contains('product-atc') || submitter?.classList.contains('product-buy-now') || submitter?.name === 'checkout';
      if (submitter && !isThemeCartButton) return;
      const isBuyNow = submitter?.classList.contains('product-buy-now') || submitter?.name === 'checkout';
      const productTemplate = form.closest('.product-template');
      const customToggle = productTemplate?.querySelector('[data-product-designer-toggle]');
      event.preventDefault();
      normalizeQuantity();
      const result = findSelectedVariant();
      const variant = result.variant;

      if (!variant?.id && !cartFallbackVariantId) {
        setMessage('Please choose a product option.', true);
        return;
      }

      if (variant?.id) setVariantInputValue(variant.id);
      variantInput.dataset.matchMode = result.mode;
      const button = submitter?.matches('button') ? submitter : form.querySelector('.product-atc');
      const label = button?.querySelector('span');
      const originalLabel = label?.textContent || (isBuyNow ? 'Buy now' : 'Add to cart');
      button?.classList.add('is-loading');
      if (button) button.disabled = true;
      if (label) label.textContent = isBuyNow ? 'Preparing...' : 'Adding...';
      setMessage();

      const designerSection = productTemplate?.querySelector('[data-product-inline-designer] [data-product-designer]');
      let customRender = null;
      if (customToggle?.getAttribute('aria-expanded') === 'true') {
        try {
          if (typeof designerSection?._anduvuForceRender !== 'function') {
            throw new Error('Custom render engine is not ready. Please try again.');
          }
          customRender = await Promise.race([
            designerSection._anduvuForceRender({ upload: false }),
            new Promise((_, reject) => window.setTimeout(() => reject(new Error('Custom image render timed out. Please try again.')), 30000))
          ]);
          if (!/^data:image\/png/i.test(customRender?.previewDataUrl || '') || !/^data:image\/png/i.test(customRender?.productionDataUrl || '')) {
            throw new Error('Custom image could not be rendered. Please try again.');
          }
        } catch (error) {
          setMessage(error.message || 'Custom image could not be rendered. Please try again.', true);
          button?.classList.remove('is-loading');
          if (button) button.disabled = false;
          if (label) label.textContent = originalLabel;
          return;
        }
      }
      const data = new FormData(form);
      if (customToggle?.getAttribute('aria-expanded') === 'true') {
        productTemplate?.querySelectorAll('[data-product-inline-designer] input[type="hidden"][name^="properties["]').forEach((field) => {
          const value = String(field.value || '');
          const isImageFile = /Product Preview|Production Print File/i.test(field.name);
          if (isImageFile) return;
          if (value && value.length <= 12000) data.set(field.name, value);
        });
        const previewBlob = await fetch(customRender.previewDataUrl).then((response) => response.blob());
        const productionBlob = await fetch(customRender.productionDataUrl).then((response) => response.blob());
        const fileStamp = `${Date.now()}-${variant?.id || 'custom'}`;
        data.set('properties[Product Preview]', new File([previewBlob], `anduvu-preview-${fileStamp}.png`, { type: 'image/png' }));
        data.set('properties[Production Print File]', new File([productionBlob], `anduvu-print-${fileStamp}.png`, { type: 'image/png' }));
        const originalUpload = form.querySelector('[data-main-original-upload]')?.files?.[0]
          || designerSection?._anduvuOriginalUploadFile;
        if (originalUpload instanceof File && originalUpload.size > 0) {
          data.set('properties[Original Uploaded Image]', originalUpload);
        }
        data.set('properties[Custom Design]', 'Yes');
      }
      const cloneFormData = (source) => {
        const clone = new FormData();
        source.forEach((value, key) => clone.append(key, value));
        return clone;
      };
      const productTitle = form.closest('.product-template')?.querySelector('h1')?.textContent?.trim() || document.title;
      propertyGroups.forEach((group) => {
        const labelText = group.querySelector('legend')?.textContent?.trim();
        const value = group.querySelector('input[type="radio"]:checked')?.value;
        if (labelText && value) data.set(`properties[${labelText}]`, value);
      });
      optionGroups.forEach((group) => {
        const labelText = group.querySelector('legend')?.textContent?.trim();
        const value = group.querySelector('input[type="radio"]:checked')?.value;
        if (labelText && value) data.set(`properties[${labelText}]`, value);
      });

      const selectedCriteria = optionGroups.map((group) => ({
        position: Math.max(0, Number.parseInt(group.dataset.optionPosition || '1', 10) - 1),
        value: normalizeOption(group.querySelector('input[type="radio"]:checked')?.value || '')
      })).filter(({ value }) => value !== '');
      const compatibleVariantIds = productVariants
        .filter((item) => item?.id && selectedCriteria.every(({ position, value }) => (
          normalizeOption(getVariantOptions(item)[position]) === value
        )))
        .map((item) => item.id);
      const productVariantIds = productVariants
        .filter((item) => item?.id)
        .map((item) => item.id);

      const allowFallbackProduct = form.dataset.allowCartFallback === 'true';
      const candidateIds = [
        variant?.id,
        data.get('id'),
        ...compatibleVariantIds,
        ...productVariantIds,
        ...(allowFallbackProduct ? [cartFallbackVariantId] : [])
      ].filter(Boolean).map(String).filter((value, index, list) => list.indexOf(value) === index);

      let response = null;
      let lastError = null;
      try {
        for (const id of candidateIds) {
          const attemptData = cloneFormData(data);
          attemptData.set('id', id);
          attemptData.set('properties[_Attempted Variant ID]', id);
          if (cartFallbackVariantId && String(id) === String(cartFallbackVariantId) && String(id) !== String(variant?.id)) {
            attemptData.set('properties[Original Product]', productTitle);
            attemptData.set('properties[Original Product URL]', window.location.pathname + window.location.search);
            attemptData.set('properties[Original Variant]', variant?.title || '');
            if (cartFallbackProductTitle) attemptData.set('properties[Cart Product]', cartFallbackProductTitle);
            attemptData.set('properties[Fallback Item]', 'Yes');
          }
          response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: attemptData
          });
          if (response.ok) break;
          lastError = await response.json().catch(() => ({}));
        }

        if (!response?.ok) {
          throw new Error(lastError?.description || lastError?.message || 'Could not add this item.');
        }
        if (isBuyNow) {
          window.location.href = `${shopRoot}checkout`;
          return;
        }
        await fetchCart();
        openCartDrawer();
        if (label) label.textContent = 'Added';
        window.setTimeout(() => {
          if (label) label.textContent = originalLabel;
        }, 1100);
      } catch (error) {
        setMessage(error.message || 'Could not add this item. Please check Shopify inventory, Markets, and variant publishing.', true);
        if (label) label.textContent = originalLabel;
      } finally {
        button?.classList.remove('is-loading');
        if (button) button.disabled = false;
      }
    });

    updateVariant();
    window.Shopify?.PaymentButton?.init?.();
  });

  document.querySelectorAll('[data-custom-text]').forEach((input) => {
    const form = input.closest('form');
    const preview = form?.querySelector('[data-custom-preview]');
    if (!preview) return;
    const syncPreview = () => {
      preview.textContent = (input.value.trim() || 'CUSTOM').toUpperCase();
    };
    input.addEventListener('input', syncPreview);
    syncPreview();
  });

  document.querySelectorAll('[data-home-custom-text]').forEach((input) => {
    const section = input.closest('.custom-builder-section');
    const preview = section?.querySelector('[data-home-custom-preview]');
    if (!preview) return;
    const syncPreview = () => {
      preview.textContent = (input.value.trim() || 'CUSTOM').toUpperCase();
    };
    input.addEventListener('input', syncPreview);
    syncPreview();
  });

  document.querySelectorAll('.custom-builder-form').forEach((form) => {
    const select = form.querySelector('[data-custom-product-select]');
    if (!select) return;
    const section = form.closest('.custom-builder-section');
    const previewImage = section?.querySelector('.tee-preview img');
    const continueLink = form.querySelector('[data-custom-continue]');
    const syncAction = () => {
      form.setAttribute('action', select.value);
      if (continueLink) continueLink.setAttribute('href', select.value);
      const selectedOption = select.options[select.selectedIndex];
      const image = selectedOption?.dataset.productImage;
      if (image && previewImage) previewImage.src = image;
    };
    select.addEventListener('change', syncAction);
    syncAction();
  });

  document.querySelectorAll('[data-product-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('.product-template-gallery');
      const image = gallery?.querySelector('.product-main-image');
      const nextSrc = button.getAttribute('data-product-thumb');
      if (!image || !nextSrc) return;
      image.src = nextSrc;
      image.srcset = '';
      const customToggle = gallery.querySelector('[data-custom-mockup-toggle]');
      if (customToggle) {
        customToggle.setAttribute('aria-pressed', 'false');
        customToggle.textContent = 'CUSTOM';
      }
      gallery.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb === button);
      });
    });
  });

  document.querySelectorAll('[data-custom-mockup-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('.product-template-gallery');
      const image = gallery?.querySelector('.product-main-image');
      const customSrc = button.dataset.customMockupSrc;
      if (!image || !customSrc) return;

      const isCustom = button.getAttribute('aria-pressed') === 'true';
      if (!isCustom) {
        button.dataset.regularSrc = image.currentSrc || image.src;
        image.src = customSrc;
        image.srcset = '';
        button.setAttribute('aria-pressed', 'true');
        button.textContent = 'BACK';
        gallery.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
      } else {
        image.src = button.dataset.regularSrc || '';
        image.srcset = '';
        button.setAttribute('aria-pressed', 'false');
        button.textContent = 'CUSTOM';
      }
    });
  });

  document.querySelectorAll('[data-product-designer-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const productInfo = button.closest('.product-template-info');
      const productTemplate = button.closest('.product-template');
      const designer = productInfo?.querySelector('[data-product-inline-designer]');
      if (!designer) return;
      const willOpen = designer.hidden;
      designer.hidden = !willOpen;
      button.setAttribute('aria-expanded', String(willOpen));
      button.setAttribute('aria-label', willOpen ? 'Hide customizer' : 'Open customizer');
      button.querySelector('span').textContent = willOpen ? 'Hide custom' : 'Custom';
      if (willOpen) {
        const gallery = productTemplate?.querySelector('.product-template-gallery');
        const originalMedia = gallery?.querySelector('.product-main-media');
        const thumbnails = gallery?.querySelector('.product-thumbnails');
        const preview = designer.querySelector('.custom-builder-preview');
        const controls = designer.querySelector('.designer-controls');
        const baseImage = preview?.querySelector('[data-designer-product-image]');
        const customSrc = designer.querySelector('[data-custom-product-select] option:checked')?.dataset.productImage;

        if (baseImage && customSrc) {
          baseImage.src = customSrc;
          designer.querySelector('[data-designer-surface]')?.classList.remove('is-rendered');
        }
        if (originalMedia) originalMedia.hidden = true;
        if (thumbnails) thumbnails.hidden = true;
        if (preview && gallery) {
          preview._anduvuHome = preview.parentNode;
          gallery.appendChild(preview);
        }
        if (controls) {
          controls._anduvuHome = controls.parentNode;
          controls.classList.add('product-custom-controls');
          button.insertAdjacentElement('afterend', controls);
        }
        designer.classList.add('is-product-custom-active');
        productTemplate?.classList.add('is-customizing-product');
        controls?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        window.setTimeout(() => {
          designer.querySelector('[data-product-designer]')?.dispatchEvent(new CustomEvent('anduvu:force-render', {
            bubbles: false,
            detail: { upload: false }
          }));
        }, 120);
      } else {
        const gallery = productTemplate?.querySelector('.product-template-gallery');
        const originalMedia = gallery?.querySelector('.product-main-media');
        const thumbnails = gallery?.querySelector('.product-thumbnails');
        const preview = gallery?.querySelector('.custom-builder-preview');
        const controls = productInfo?.querySelector('.designer-controls');
        if (preview?._anduvuHome) preview._anduvuHome.appendChild(preview);
        if (controls?._anduvuHome) controls._anduvuHome.appendChild(controls);
        controls?.classList.remove('product-custom-controls');
        if (originalMedia) originalMedia.hidden = false;
        if (thumbnails) thumbnails.hidden = false;
        designer.classList.remove('is-product-custom-active');
        productTemplate?.classList.remove('is-customizing-product');
      }
    });
  });

  document.querySelectorAll('[data-product-zoom]').forEach((media) => {
    const image = media.querySelector('.product-main-image');
    if (!image) return;
    media.addEventListener('mousemove', (event) => {
      const rect = media.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      image.style.transformOrigin = `${x}% ${y}%`;
    });
    media.addEventListener('mouseleave', () => {
      image.style.transformOrigin = 'center';
    });
  });

  const detectPaymentWallets = async () => {
    const wallets = [];
    try {
      if (window.ApplePaySession && ApplePaySession.canMakePayments()) wallets.push('Apple Pay');
    } catch {
      /* Apple Pay detection is browser-gated. */
    }
    try {
      if (window.PaymentRequest) {
        const request = new PaymentRequest(
          [{ supportedMethods: 'basic-card' }],
          { total: { label: 'ANDUVU', amount: { currency: 'CAD', value: '1.00' } } }
        );
        if (request.canMakePayment && await request.canMakePayment()) wallets.push('saved card');
      }
    } catch {
      /* PaymentRequest support varies by browser and market. */
    }
    document.documentElement.dataset.availableWallets = wallets.join(',');
    document.querySelectorAll('[data-wallet-note]').forEach((note) => {
      if (!wallets.length) return;
      note.hidden = false;
      note.textContent = `Fast checkout available: ${wallets.join(', ')}. Shopify will show the best eligible payment button.`;
    });
  };
  detectPaymentWallets();

  const syncCustomTypeFields = (root) => {
    const selected = root.querySelector('[data-custom-type-radio]:checked')?.value || 'Text';
    root.querySelectorAll('[data-custom-image-fields]').forEach((panel) => {
      panel.hidden = selected !== 'Image';
    });
  };

  document.querySelectorAll('.customizer-panel, .custom-builder-section').forEach((root) => {
    root.querySelectorAll('[data-custom-type-radio]').forEach((input) => {
      input.addEventListener('change', () => syncCustomTypeFields(root));
    });
    syncCustomTypeFields(root);
  });

  document.querySelectorAll('.custom-builder-section:not([data-product-designer])').forEach((section) => {
    const input = section.querySelector('[data-home-custom-text]');
    const draftCard = document.querySelector('[data-custom-draft-card]');
    const draftText = document.querySelector('[data-custom-draft-text]');
    const fileInput = section.querySelector('input[type="file"]');
    const imageUrlInput = section.querySelector('#HomeCustomImage');
    const previewImage = section.querySelector('.tee-preview img');
    const artPreview = section.querySelector('[data-home-custom-art]');
    const applyButton = section.querySelector('[data-apply-home-custom]');
    const previewText = section.querySelector('[data-home-custom-preview]');
    const key = 'anduvuCustomDraft';

    const renderDraft = () => {
      let draft = null;
      try {
        draft = JSON.parse(localStorage.getItem(key) || 'null');
      } catch {
        draft = null;
      }
      if (!draftCard || !draftText || !draft?.text) return;
      draftText.textContent = draft.text;
      draftCard.hidden = false;
    };

    input?.addEventListener('input', () => {
      localStorage.setItem(key, JSON.stringify({ text: input.value.trim(), savedAt: Date.now() }));
      renderDraft();
    });

    fileInput?.addEventListener('change', () => {
      const file = fileInput.files?.[0];
      if (!file || !artPreview) return;
      artPreview.src = URL.createObjectURL(file);
      artPreview.hidden = false;
      if (previewText) previewText.hidden = true;
    });

    imageUrlInput?.addEventListener('input', () => {
      const value = imageUrlInput.value.trim();
      if (!artPreview || !/^https?:\/\//i.test(value)) return;
      artPreview.src = value;
      artPreview.hidden = false;
      if (previewText) previewText.hidden = true;
    });

    applyButton?.addEventListener('click', () => {
      const text = (input?.value.trim() || 'CUSTOM').toUpperCase();
      const isImageMode = section.querySelector('[data-custom-type-radio]:checked')?.value === 'Image';
      if (previewText) {
        previewText.textContent = text;
        previewText.hidden = isImageMode && artPreview && !artPreview.hidden;
      }
      localStorage.setItem(key, JSON.stringify({
        text,
        type: isImageMode ? 'Image' : 'Text',
        savedAt: Date.now()
      }));
      applyButton.classList.add('is-applied');
      applyButton.querySelector('span').textContent = 'Custom preview applied';
      renderDraft();
    });

    renderDraft();
  });

  document.querySelectorAll('.customizer-panel').forEach((panel) => {
    const input = panel.querySelector('[data-custom-text]');
    const preview = panel.querySelector('[data-custom-preview]');
    const fileInput = panel.querySelector('input[type="file"]');
    const imageUrlInput = panel.querySelector('#CustomImageUrl');
    const previewBox = panel.querySelector('.custom-preview-box');
    const artPreview = panel.querySelector('[data-product-custom-art]');

    fileInput?.addEventListener('change', () => {
      const file = fileInput.files?.[0];
      if (!file || !previewBox || !artPreview) return;
      artPreview.src = URL.createObjectURL(file);
      artPreview.hidden = false;
      previewBox.classList.add('has-image');
      if (preview) preview.hidden = true;
    });

    imageUrlInput?.addEventListener('input', () => {
      const value = imageUrlInput.value.trim();
      if (!previewBox || !artPreview || !/^https?:\/\//i.test(value)) return;
      artPreview.src = value;
      artPreview.hidden = false;
      previewBox.classList.add('has-image');
      if (preview) preview.hidden = true;
    });

    input?.addEventListener('input', () => {
      if (!preview) return;
      preview.textContent = (input.value.trim() || 'CUSTOM').toUpperCase();
      preview.hidden = false;
    });
  });

  document.querySelectorAll('[data-product-designer]').forEach((section) => {
    const form = section.querySelector('form');
    const productSelect = section.querySelector('[data-custom-product-select]');
    const variantInput = section.querySelector('[data-designer-variant-id]');
    const sizeSelect = section.querySelector('[data-designer-size]');
    const shirtColorSelect = section.querySelector('[data-designer-shirt-color]');
    const shirtSwatch = section.querySelector('[data-designer-shirt-swatch]');
    const notesInput = section.querySelector('#HomeCustomNotes');
    const priceLabel = section.querySelector('[data-designer-price]');
    const totalLabel = section.querySelector('[data-designer-total]');
    const quantityInput = section.querySelector('[data-designer-quantity]');
    const previewCart = section.querySelector('[data-designer-preview-cart]');
    const previewThumbs = section.querySelector('[data-designer-preview-thumbs]');
    const surface = section.querySelector('[data-designer-surface]');
    const productImage = section.querySelector('[data-designer-product-image]');
    const printArea = section.querySelector('[data-print-area]');
    const printAreaResizeHandles = section.querySelectorAll('[data-print-area-resize]');
    const textInput = section.querySelector('[data-home-custom-text]');
    const customerTextInput = section.querySelector('[data-designer-customer-text]');
    const fontSelect = section.querySelector('[data-designer-font]');
    const colorInput = section.querySelector('[data-designer-print-color]');
    const uploadInput = section.querySelector('[data-designer-upload]');
    const mainOriginalUploadInput = section.closest('.product-template')?.querySelector('[data-main-original-upload]');
    const uploadTriggers = section.querySelectorAll('[data-designer-upload-trigger]');
    const imageLibraryButtons = section.querySelectorAll('[data-designer-open-image-library]');
    const imageModal = section.querySelector('[data-designer-image-modal]');
    const imageModalClose = section.querySelector('[data-designer-image-modal-close]');
    const scaleInput = section.querySelector('[data-designer-scale]');
    const rotateInput = section.querySelector('[data-designer-rotate]');
    const fontSizeInput = section.querySelector('[data-designer-font-size]');
    const widthInput = section.querySelector('[data-designer-width]');
    const borderWidthInput = section.querySelector('[data-designer-border-width]');
    const borderColorInput = section.querySelector('[data-designer-border-color]');
    const boldButton = section.querySelector('[data-designer-bold]');
    const italicButton = section.querySelector('[data-designer-italic]');
    const editorPanel = section.querySelector('.designer-inline-tools');
    const editorClose = section.querySelector('[data-designer-editor-close]');
    const editorExpand = section.querySelector('[data-designer-editor-expand]');
    const layerList = section.querySelector('[data-designer-layer-list]');
    const addLayerButton = section.querySelector('[data-designer-add-layer]');
    const newLayerMenu = section.querySelector('[data-designer-new-layer-menu]');
    const addTextButton = section.querySelector('[data-designer-add-text]');
    const addImageButton = section.querySelector('[data-designer-add-image]');
    const applyButton = section.querySelector('[data-apply-home-custom]');
    const deleteButton = section.querySelector('[data-designer-delete]');
    const resetButton = section.querySelector('[data-designer-reset]');
    const renderButton = section.querySelector('[data-designer-preview]');
    const finalPreview = section.querySelector('[data-designer-final-preview]');
    const finalPreviewImage = section.querySelector('[data-designer-final-image]');
    const finalPreviewUrl = section.querySelector('[data-designer-preview-url]');
    const loadingIndicator = section.querySelector('[data-designer-loading]');
    const statusMessage = section.querySelector('[data-designer-status]');
    const previewProperty = section.querySelector('[data-designer-preview-file]');
    const productionProperty = section.querySelector('[data-designer-production-file]');
    const dataProperty = section.querySelector('[data-designer-data]');
    const textProperty = section.querySelector('[data-designer-text-property]');
    const colorProperty = section.querySelector('[data-designer-color-property]');
    const sizeProperty = section.querySelector('[data-designer-size-property]');
    const statusProperty = section.querySelector('[data-designer-status-property]');
    const aiPromptProperty = section.querySelector('[data-designer-ai-prompt-property]');
    const bgPresetButtons = section.querySelectorAll('[data-bg-preset]');
    const textPresetButtons = section.querySelectorAll('[data-text-preset]');
    const bgEnabledInput = section.querySelector('[data-bg-enabled]');
    const bgUploadTrigger = section.querySelector('[data-bg-upload-trigger]');
    const bgUploadInput = section.querySelector('[data-bg-upload]');
    const textEnabledInputs = section.querySelectorAll('[data-text-enabled]');
    if (!form || !surface || !printArea) return;

    let activeLayer = null;
    let dragState = null;
    let resizeState = null;
    let rotateState = null;
    let areaDragState = null;
    let areaResizeState = null;
    let lastRender = null;
    let baseProductImageSrc = section.dataset.activeMockupSrc || productImage?.currentSrc || productImage?.src || '';
    let layerCounter = 0;
    let previewCounter = 0;
    let didRenderDefaultTemplate = false;
    let autoRenderTimer = null;
    let editRevision = 0;
    let customerImageEditing = false;
    let textEditing = false;
    let immediateRenderRevision = -1;
    let immediateRenderPromise = null;
    let originalCustomerUploadUrl = '';
    section._anduvuOriginalUploadFile = null;
    const renderedPreviews = [];
    // Preview and production artwork are rendered in-browser. Remote image
    // render/upload services stay disabled so typing and preview generation have
    // no network round trip; normal Shopify cart requests are unaffected.
    const cloudinaryCloud = '';
    const cloudinaryPreset = '';
    const renderServiceUrl = '';
    const canUploadToCloud = false;
    const canRemoteRender = false;
    const canUploadDesignFiles = false;

    const setDesignerStatus = (message) => {
      if (statusMessage) statusMessage.textContent = message;
      if (statusProperty) statusProperty.value = message;
    };

    const setRenderingState = (isRendering) => {
      section.classList.toggle('is-rendering', isRendering);
      if (surface) surface.classList.toggle('is-rendering', isRendering);
      if (loadingIndicator) loadingIndicator.hidden = !isRendering;
      [renderButton, applyButton].forEach((button) => {
        if (button) button.disabled = isRendering;
      });
    };

    const money = (cents) => {
      const value = Number(cents || 0) / 100;
      return `$${value.toFixed(2)} CAD`;
    };

    const selectedPreviewItems = () => {
      return renderedPreviews.filter((item) => item.selected);
    };

    const parseVariants = () => {
      const option = productSelect?.options[productSelect.selectedIndex];
      if (!option) return [];
      try {
        return JSON.parse(option.dataset.variants || '[]');
      } catch {
        return [];
      }
    };

    const currentProductPrice = () => {
      const variants = parseVariants();
      const variant = variants.find((item) => String(item.id) === String(variantInput?.value)) || variants[0];
      return Number(variant?.price || productSelect?.options[productSelect.selectedIndex]?.dataset.price || 0);
    };

    const updateTotals = () => {
      const unitPrice = currentProductPrice();
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const selectedCount = renderedPreviews.length ? selectedPreviewItems().length : 1;
      if (priceLabel) priceLabel.textContent = money(unitPrice);
      if (totalLabel) totalLabel.textContent = money(unitPrice * selectedCount * quantity);
    };

    const renderPreviewThumbs = () => {
      if (!previewThumbs || !previewCart) return;
      previewCart.hidden = renderedPreviews.length === 0;
      previewThumbs.innerHTML = '';
      renderedPreviews.forEach((item) => {
        const label = document.createElement('label');
        label.className = 'designer-preview-thumb';
        label.innerHTML = `
          <input type="checkbox" ${item.selected ? 'checked' : ''}>
          <img src="${item.previewDataUrl}" alt="Preview ${item.index}">
          <span>Preview ${item.index}</span>
        `;
        const checkbox = label.querySelector('input');
        checkbox.addEventListener('change', () => {
          item.selected = checkbox.checked;
          updateTotals();
        });
        previewThumbs.appendChild(label);
      });
      updateTotals();
    };

    const addRenderedPreview = (render) => {
      if (!render?.previewDataUrl) return;
      renderedPreviews.forEach((item) => {
        item.selected = false;
      });
      renderedPreviews.push({
        index: ++previewCounter,
        selected: true,
        previewDataUrl: render.previewDataUrl,
        productionDataUrl: render.productionDataUrl,
        previewUrl: render.previewUrl || '',
        productionUrl: render.productionUrl || '',
        designData: dataProperty?.value || ''
      });
      renderPreviewThumbs();
    };

    const clearOriginalUploadRenderOverlay = () => {
      surface?.querySelector('.designer-original-upload-overlay')?.remove();
      surface?.querySelector('.designer-render-foreground')?.remove();
    };

    const showOriginalUploadRenderOverlay = () => {
      clearOriginalUploadRenderOverlay();
      const sourceLayer = surface?.querySelector('.designer-layer[data-customer-upload="true"]');
      const sourceImage = sourceLayer?.querySelector('.designer-layer-content img');
      if (!sourceLayer || !sourceImage?.src?.startsWith('blob:')) return;

      const printAreaData = currentPrintAreaData();
      const right = Math.max(0, 100 - printAreaData.left - printAreaData.width);
      const bottom = Math.max(0, 100 - printAreaData.top - printAreaData.height);
      const overlay = document.createElement('div');
      overlay.className = 'designer-original-upload-overlay';
      overlay.style.clipPath = `inset(${Math.max(0, printAreaData.top)}% ${right}% ${bottom}% ${Math.max(0, printAreaData.left)}%)`;
      overlay.setAttribute('aria-hidden', 'true');

      const renderedLayer = sourceLayer.cloneNode(true);
      renderedLayer.classList.remove('designer-layer', 'is-active');
      renderedLayer.classList.add('designer-original-upload-layer', 'designer-layer-image');
      renderedLayer.removeAttribute('tabindex');
      renderedLayer.removeAttribute('role');
      renderedLayer.removeAttribute('aria-label');
      renderedLayer.querySelectorAll('.designer-move-handle, .designer-resize-handle, .designer-rotate-handle').forEach((handle) => handle.remove());
      overlay.appendChild(renderedLayer);
      surface.appendChild(overlay);
    };

    const showRenderedTextForeground = (dataUrl) => {
      if (!dataUrl || !surface?.querySelector('.designer-layer[data-customer-upload="true"]')) return;
      const foreground = document.createElement('img');
      foreground.className = 'designer-render-foreground';
      foreground.src = dataUrl;
      foreground.alt = '';
      foreground.setAttribute('aria-hidden', 'true');
      surface.appendChild(foreground);
    };

    const enterEditMode = () => {
      editRevision += 1;
      window.clearTimeout(autoRenderTimer);
      autoRenderTimer = null;
      clearOriginalUploadRenderOverlay();
      if (!productImage || !surface?.classList.contains('is-rendered')) return;
      productImage.src = baseProductImageSrc;
      surface.classList.remove('is-rendered');
      if (renderButton) renderButton.textContent = 'Preview ready';
    };

    const shirtColorMap = {
      white: '#f7f7f2',
      black: '#111',
      'light pink': '#f7cddd',
      'light blue': '#cce8f6',
      sand: '#d8c4a2',
      charcoal: '#303238',
      navy: '#141d33',
      daisy: '#f7d23b',
      red: '#c8272d',
      'sport grey': '#b8b8b8',
      royal: '#1d54aa'
    };

    const syncBlankPatch = () => {
      const patch = section.querySelector('[data-print-clean-patch]');
      const color = shirtColorSelect?.value?.toLowerCase() || 'white';
      const swatchColor = shirtColorMap[color] || '#f7f7f2';
      if (patch) patch.style.background = swatchColor;
      if (shirtSwatch) shirtSwatch.style.background = swatchColor;
    };

    const syncOriginalUploadToProductForm = (file = null) => {
      if (!mainOriginalUploadInput) return;
      if (!(file instanceof File)) {
        mainOriginalUploadInput.value = '';
        mainOriginalUploadInput._anduvuOriginalUploadFile = null;
        return;
      }
      mainOriginalUploadInput._anduvuOriginalUploadFile = file;
      try {
        if (uploadInput?.files?.[0] === file) {
          mainOriginalUploadInput.files = uploadInput.files;
          if (mainOriginalUploadInput.files?.[0]) return;
        }
      } catch {
        /* Fall through to a new FileList containing the same File object. */
      }
      try {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        mainOriginalUploadInput.files = transfer.files;
      } catch {
        /* The cart FormData fallback still sends the untouched File object. */
      }
    };

    const clearOriginalCustomerUpload = () => {
      clearOriginalUploadRenderOverlay();
      if (originalCustomerUploadUrl) URL.revokeObjectURL(originalCustomerUploadUrl);
      originalCustomerUploadUrl = '';
      section._anduvuOriginalUploadFile = null;
      syncOriginalUploadToProductForm();
      if (uploadInput) uploadInput.value = '';
    };

    const clearDesignLayers = () => {
      clearOriginalCustomerUpload();
      surface.querySelectorAll('.designer-layer').forEach((layer) => layer.remove());
      activeLayer = null;
      updateLayerPanel();
      updateDesignerProperties();
    };

    const currentPrintAreaData = () => {
      const surfaceRect = surface.getBoundingClientRect();
      const areaRect = printArea.getBoundingClientRect();
      return {
        left: surfaceRect.width ? ((areaRect.left - surfaceRect.left) / surfaceRect.width) * 100 : 0,
        top: surfaceRect.height ? ((areaRect.top - surfaceRect.top) / surfaceRect.height) * 100 : 0,
        width: surfaceRect.width ? (areaRect.width / surfaceRect.width) * 100 : 100,
        height: surfaceRect.height ? (areaRect.height / surfaceRect.height) * 100 : 100
      };
    };

    const printAreaLayerBox = () => {
      const area = currentPrintAreaData();
      const styleArea = {
        left: Number.parseFloat(printArea.style.left),
        top: Number.parseFloat(printArea.style.top),
        width: Number.parseFloat(printArea.style.width),
        height: Number.parseFloat(printArea.style.height)
      };
      if (Number.isFinite(styleArea.left) && Number.isFinite(styleArea.top) && Number.isFinite(styleArea.width) && Number.isFinite(styleArea.height)) {
        return {
          x: styleArea.left + styleArea.width / 2,
          y: styleArea.top + styleArea.height / 2,
          width: styleArea.width,
          height: styleArea.height,
          topTextY: styleArea.top,
          bottomTextY: styleArea.top,
          backgroundY: styleArea.top + styleArea.height,
          backgroundHeight: styleArea.height
        };
      }
      return {
        x: area.left + area.width / 2,
        y: area.top + area.height / 2,
        width: area.width,
        height: area.height,
        topTextY: area.top,
        bottomTextY: area.top,
        backgroundY: area.top + area.height,
        backgroundHeight: area.height
      };
    };

    const lockTemplateLayer = (layer) => {
      if (!layer) return;
      layer.dataset.layoutLocked = 'true';
      layer.dataset.scale = '100';
      layer.dataset.rotate = '0';
    };

    const settingNumber = (name, fallback) => {
      const value = Number.parseFloat(section.dataset[name] || '');
      return Number.isFinite(value) ? value : fallback;
    };

    const syncFixedTemplateLayout = () => {
      const box = printAreaLayerBox();
      const surfaceRect = surface.getBoundingClientRect();
      const surfaceWidth = Math.max(1, surfaceRect.width || 1);
      const surfaceHeight = Math.max(1, surfaceRect.height || 1);
      const textWidth = settingNumber('textWidth', box.width * .9);
      const textHeight = settingNumber('textHeight', 10);
      const textCenterX = settingNumber('textLeft', box.x);
      const textTop = settingNumber('textTop', box.topTextY);
      const backgroundWidth = settingNumber('backgroundWidth', box.width);
      const backgroundHeight = settingNumber('backgroundHeight', box.backgroundHeight);
      const backgroundCenterX = settingNumber('backgroundLeft', box.x);
      const backgroundTop = settingNumber('backgroundTop', box.backgroundY - backgroundHeight);
      getLayers().forEach((layer) => {
        if (layer.dataset.type === 'text') {
          const measuredRatios = { galaxy: 385 / 900, pink: 387 / 900, gold: 342 / 900 };
          const uploadedFrameRatio = Number.parseFloat(layer.dataset.textFrameRatio || '');
          const styleRatio = Number.isFinite(uploadedFrameRatio) && uploadedFrameRatio > 0
            ? uploadedFrameRatio
            : (measuredRatios[layer.dataset.textStyle] || (textHeight / Math.max(1, textWidth)));
          const fittedHeight = textWidth * styleRatio;
          const fontPx = Math.max(22, Math.min(150, surfaceHeight * (fittedHeight / 100) * .9, surfaceWidth * (textWidth / 100) * .48));
          lockTemplateLayer(layer);
          layer.dataset.x = String(textCenterX);
          layer.dataset.y = String(textTop + fittedHeight / 2);
          layer.dataset.width = String(textWidth);
          layer.dataset.height = fittedHeight.toFixed(3);
          layer.dataset.fontSize = String(Math.round(fontPx));
          layer.style.fontSize = `${layer.dataset.fontSize}px`;
          updateLayerTransform(layer);
          return;
        }

        if (layer.dataset.presetBackground === 'true') {
          lockTemplateLayer(layer);
          layer.dataset.x = String(backgroundCenterX);
          layer.dataset.y = String(backgroundTop + backgroundHeight / 2);
          layer.dataset.width = String(backgroundWidth);
          layer.dataset.height = String(backgroundHeight);
          updateLayerTransform(layer);
        }
      });
    };

    const setVariantForSize = () => {
      const option = productSelect?.options[productSelect.selectedIndex];
      if (!option || !variantInput) return;
      const variants = parseVariants();
      const normalizeOption = (value) => String(value || '').trim().toLowerCase();
      const selectedSize = normalizeOption(sizeSelect?.value);
      const selectedColor = normalizeOption(shirtColorSelect?.value);
      const match = variants.find((variant) => {
        const options = [variant.option1, variant.option2, variant.option3].filter(Boolean).map(normalizeOption);
        return (!selectedSize || options.includes(selectedSize)) && (!selectedColor || options.includes(selectedColor));
      }) || variants[0];
      if (match?.id) variantInput.value = match.id;
      updateTotals();
    };

    const fillSelect = (select, values) => {
      if (!select) return;
      select.innerHTML = '';
      const cleaned = values.filter((value) => value && value !== 'Default Title');
      (cleaned.length ? cleaned : ['Default']).forEach((value) => {
        const item = document.createElement('option');
        item.value = value;
        item.textContent = value;
        select.appendChild(item);
      });
    };

    const syncVariantOptions = () => {
      const variants = parseVariants();
      const allValues = [...new Set(variants.flatMap((variant) => [variant.option1, variant.option2, variant.option3]).filter(Boolean))];
      const sizePattern = /^(xs|s|m|l|xl|2xl|3xl|4xl|5xl|6xl|small|medium|large|x-large)$/i;
      const sizeValues = allValues.filter((value) => sizePattern.test(String(value).trim()));
      const colorValues = allValues.filter((value) => !sizePattern.test(String(value).trim()) && value !== 'Default Title');
      const option1Values = [...new Set(variants.map((variant) => variant.option1).filter(Boolean))];
      fillSelect(sizeSelect, sizeValues.length ? sizeValues : option1Values);
      fillSelect(shirtColorSelect, colorValues.length ? colorValues : ['White']);
      const colorRow = shirtColorSelect?.closest('.designer-control-row');
      if (colorRow) colorRow.hidden = colorValues.length === 0;
    };

    const syncProduct = () => {
      const option = productSelect?.options[productSelect.selectedIndex];
      if (!option) return;
      const image = option.dataset.productImage;
      if (image && productImage) {
        baseProductImageSrc = image;
        productImage.crossOrigin = 'anonymous';
        productImage.addEventListener('load', () => syncUsableArea(), { once: true });
        productImage.src = image;
        surface.classList.remove('is-rendered');
      }
      resetUsableArea();
      clearDesignLayers();
      didRenderDefaultTemplate = false;
      renderedPreviews.length = 0;
      renderPreviewThumbs();
      if (finalPreview) finalPreview.hidden = true;
      syncVariantOptions();
      setVariantForSize();
      syncBlankPatch();
      applyDefaultTemplate();
      updateTotals();
    };

    const getLayers = () => Array.from(surface.querySelectorAll('.designer-layer'));

    const layerStackRank = (layer) => {
      if (layer.dataset.type === 'text') return 0;
      if (layer.dataset.customerUpload === 'true') return 1;
      if (layer.dataset.presetBackground === 'true') return 3;
      return 2;
    };

    const updateLayerStack = () => {
      const layers = getLayers().sort((first, second) => layerStackRank(first) - layerStackRank(second));
      layers.forEach((layer) => surface.appendChild(layer));
      layers.forEach((layer, index) => {
        layer.style.zIndex = String(20 + layers.length - index);
      });
    };

    const selectLayer = (layer) => {
      surface.querySelectorAll('.designer-layer').forEach((item) => {
        item.classList.toggle('is-active', item === layer && item.dataset.directEditable === 'true');
      });
      activeLayer = layer;
      updateLayerPanel();
      if (!layer) return;
      if (textInput) textInput.value = layer.dataset.type === 'text' ? layerText(layer) : '';
      if (customerTextInput && layer.dataset.type === 'text') customerTextInput.value = textInput ? textInput.value : layerText(layer);
      if (scaleInput) scaleInput.value = layer.dataset.scale || '100';
      if (rotateInput) rotateInput.value = layer.dataset.rotate || '0';
      if (fontSizeInput) fontSizeInput.value = layer.dataset.fontSize || '54';
      if (widthInput) widthInput.value = layer.dataset.width || '78';
      if (borderWidthInput) borderWidthInput.value = layer.dataset.borderWidth || '0';
      if (borderColorInput) borderColorInput.value = layer.dataset.borderColor || '#000000';
      if (boldButton) boldButton.setAttribute('aria-pressed', layer.dataset.weight !== '400' ? 'true' : 'false');
      if (italicButton) italicButton.setAttribute('aria-pressed', layer.dataset.italic === 'true' ? 'true' : 'false');
    };

    const updateLayerTransform = (layer) => {
      if (!layer) return;
      const x = Number(layer.dataset.x || 50);
      const y = Number(layer.dataset.y || 50);
      const scale = Number(layer.dataset.scale || 100) / 100;
      const rotate = Number(layer.dataset.rotate || 0);
      const width = Number(layer.dataset.width || (layer.dataset.type === 'text' ? 78 : 44));
      const height = Number(layer.dataset.height || 34);
      const isCustomerUpload = layer.dataset.customerUpload === 'true';
      layer.style.left = `${x}%`;
      layer.style.top = `${y}%`;
      layer.style.width = `${Math.max(isCustomerUpload ? 1 : 20, Math.min(isCustomerUpload ? 1000 : 240, width))}%`;
      layer.style.height = `${Math.max(isCustomerUpload ? 1 : 12, Math.min(isCustomerUpload ? 1000 : 240, height))}%`;
      const borderWidth = Number(layer.dataset.borderWidth || 0);
      const borderColor = layer.dataset.borderColor || '#000000';
      if (layer.dataset.type === 'text') {
        layer.style.boxShadow = 'none';
        layer.style.webkitTextStroke = borderWidth > 0 ? `${borderWidth}px ${borderColor}` : '';
        layer.style.textStroke = borderWidth > 0 ? `${borderWidth}px ${borderColor}` : '';
        const content = layer.querySelector('.designer-layer-content');
        if (content) {
          content.style.webkitTextStroke = borderWidth > 0 ? `${borderWidth}px ${borderColor}` : '';
          content.style.textStroke = borderWidth > 0 ? `${borderWidth}px ${borderColor}` : '';
        }
      } else {
        layer.style.webkitTextStroke = '';
        layer.style.textStroke = '';
        layer.style.boxShadow = borderWidth > 0 ? `inset 0 0 0 ${borderWidth}px ${borderColor}` : 'none';
      }
      layer.style.transform = `translate(-50%, -50%) scale(${scale}) rotate(${rotate}deg)`;
      if (layer.dataset.type === 'text') queueTextFit(layer);
    };

    const fitImageLayerBoxToImage = (layer, image) => {
      if (!layer || layer.dataset.type !== 'image' || !image) return;
      const naturalWidth = image.naturalWidth || image.width || 0;
      const naturalHeight = image.naturalHeight || image.height || 0;
      if (!naturalWidth || !naturalHeight) return;
      layer.dataset.aspectRatio = String(naturalHeight / naturalWidth);
      if (layer.dataset.presetBackground === 'true') {
        syncFixedTemplateLayout();
        updateDesignerProperties();
        return;
      }
      const surfaceRect = surface.getBoundingClientRect();
      if (layer.dataset.customerUpload === 'true') {
        const printAreaData = currentPrintAreaData();
        const surfaceWidth = Math.max(1, surfaceRect.width);
        const surfaceHeight = Math.max(1, surfaceRect.height);
        const fullWidthPx = (printAreaData.width / 100) * surfaceWidth;
        const heightAtFullWidthPx = fullWidthPx * (naturalHeight / naturalWidth);
        const widthPercent = printAreaData.width;
        const heightPercent = (heightAtFullWidthPx / surfaceHeight) * 100;
        layer.dataset.x = (printAreaData.left + printAreaData.width / 2).toFixed(2);
        layer.dataset.y = (printAreaData.top + printAreaData.height / 2).toFixed(2);
        layer.dataset.width = Math.max(1, Math.min(1000, widthPercent)).toFixed(2);
        layer.dataset.height = Math.max(1, Math.min(1000, heightPercent)).toFixed(2);
      } else {
        const width = Number(layer.dataset.width || 40);
        const widthPx = (width / 100) * Math.max(1, surfaceRect.width);
        const heightPercent = ((widthPx * (naturalHeight / naturalWidth)) / Math.max(1, surfaceRect.height)) * 100;
        layer.dataset.height = Math.max(8, Math.min(240, heightPercent)).toFixed(2);
      }
      updateLayerTransform(layer);
      updateDesignerProperties();
    };

    const updateLayerPanel = () => {
      if (!layerList) return;
      layerList.innerHTML = '';
      getLayers().forEach((layer, index) => {
        const item = document.createElement('div');
        item.className = 'designer-layer-tab';
        item.classList.toggle('is-active', layer === activeLayer);

        const selectButton = document.createElement('button');
        selectButton.type = 'button';
        selectButton.className = 'designer-layer-select';
        selectButton.textContent = layer.dataset.name || `Layer ${index + 1}`;
        selectButton.addEventListener('click', () => selectLayer(layer));

        const upButton = document.createElement('button');
        upButton.type = 'button';
        upButton.className = 'designer-layer-order';
        upButton.textContent = '↑';
        upButton.disabled = index === 0;
        upButton.addEventListener('click', () => {
          const previous = layer.previousElementSibling;
          if (previous?.classList.contains('designer-layer')) surface.insertBefore(layer, previous);
          updateLayerStack();
          selectLayer(layer);
          updateDesignerProperties();
        });

        const downButton = document.createElement('button');
        downButton.type = 'button';
        downButton.className = 'designer-layer-order';
        downButton.textContent = '↓';
        downButton.disabled = index === getLayers().length - 1;
        downButton.addEventListener('click', () => {
          const next = layer.nextElementSibling;
          if (next?.classList.contains('designer-layer')) surface.insertBefore(next, layer);
          updateLayerStack();
          selectLayer(layer);
          updateDesignerProperties();
        });

        const deleteLayerButton = document.createElement('button');
        deleteLayerButton.type = 'button';
        deleteLayerButton.className = 'designer-layer-delete';
        deleteLayerButton.textContent = '×';
        deleteLayerButton.addEventListener('click', () => {
          layer.remove();
          activeLayer = getLayers()[0] || null;
          if (activeLayer) selectLayer(activeLayer);
          updateLayerStack();
          updateLayerPanel();
          updateDesignerProperties();
        });

        item.append(selectButton, upButton, downButton, deleteLayerButton);
        layerList.appendChild(item);
      });
    };

    const makeLayer = (type) => {
      const layer = document.createElement('div');
      layer.tabIndex = -1;
      layer.setAttribute('role', 'presentation');
      layer.className = `designer-layer designer-layer-${type}`;
      layer.dataset.type = type;
      layer.dataset.id = `layer-${Date.now()}-${++layerCounter}`;
      layer.dataset.name = `${type === 'text' ? 'Text' : 'Image'} ${layerCounter}`;
      layer.dataset.x = '50';
      layer.dataset.y = type === 'text' ? '42' : '48';
      layer.dataset.scale = '100';
      layer.dataset.rotate = '0';
      layer.dataset.width = type === 'text' ? '100' : '100';
      layer.dataset.height = type === 'image' ? '58' : '18';
      layer.dataset.fontSize = '54';
      layer.dataset.weight = '900';
      layer.dataset.italic = 'false';
      layer.dataset.borderWidth = '0';
      layer.dataset.borderColor = '#000000';
      layer.addEventListener('pointerdown', (event) => {
        if (layer.dataset.directEditable !== 'true') return;
        enterEditMode();
        customerImageEditing = true;
        selectLayer(layer);
        if (layer.dataset.layoutLocked === 'true') return;
        if (event.target.closest('.designer-rotate-handle')) {
          event.preventDefault();
          event.stopPropagation();
          const rect = layer.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;
          rotateState = {
            layer,
            centerX,
            centerY,
            startAngle: Math.atan2(event.clientY - centerY, event.clientX - centerX),
            startRotate: Number(layer.dataset.rotate || 0)
          };
          layer.setPointerCapture(event.pointerId);
          return;
        }
        if (event.target.closest('.designer-resize-handle')) {
          event.preventDefault();
          event.stopPropagation();
          const rect = layer.getBoundingClientRect();
          const areaRect = surface.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;
          resizeState = {
            layer,
            centerX,
            centerY,
            startDistance: Math.max(1, Math.hypot(event.clientX - centerX, event.clientY - centerY)),
            startWidth: (Number(layer.dataset.width || 46) / 100) * areaRect.width,
            startHeight: (Number(layer.dataset.height || 34) / 100) * areaRect.height,
            areaWidth: areaRect.width,
            areaHeight: areaRect.height
          };
          layer.setPointerCapture(event.pointerId);
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        const rect = surface.getBoundingClientRect();
        const layerRect = layer.getBoundingClientRect();
        dragState = {
          layer,
          rect,
          offsetX: event.clientX - (layerRect.left + layerRect.width / 2),
          offsetY: event.clientY - (layerRect.top + layerRect.height / 2)
        };
        layer.setPointerCapture(event.pointerId);
      });
      layer.addEventListener('pointermove', (event) => {
        if (layer.dataset.layoutLocked === 'true') return;
        if (rotateState && rotateState.layer === layer) {
          const angle = Math.atan2(event.clientY - rotateState.centerY, event.clientX - rotateState.centerX);
          const delta = (angle - rotateState.startAngle) * (180 / Math.PI);
          const nextRotate = ((rotateState.startRotate + delta + 540) % 360) - 180;
          layer.dataset.rotate = nextRotate.toFixed(1);
          if (rotateInput) rotateInput.value = String(Math.round(nextRotate));
          updateLayerTransform(layer);
          updateDesignerProperties();
          return;
        }
        if (resizeState && resizeState.layer === layer) {
          const currentDistance = Math.max(1, Math.hypot(
            event.clientX - resizeState.centerX,
            event.clientY - resizeState.centerY
          ));
          const resizeScale = currentDistance / resizeState.startDistance;
          const nextWidthPx = Math.max(
            resizeState.areaWidth * .2,
            Math.min(resizeState.areaWidth * 2.4, resizeState.startWidth * resizeScale)
          );
          const aspectRatio = Number(layer.dataset.aspectRatio || (resizeState.startHeight / Math.max(1, resizeState.startWidth)));
          const nextWidth = (nextWidthPx / Math.max(1, resizeState.areaWidth)) * 100;
          const nextHeight = ((nextWidthPx * aspectRatio) / Math.max(1, resizeState.areaHeight)) * 100;
          layer.dataset.width = Math.max(20, Math.min(240, nextWidth)).toFixed(2);
          layer.dataset.height = Math.max(
            layer.dataset.customerUpload === 'true' ? 1 : 8,
            Math.min(layer.dataset.customerUpload === 'true' ? 1000 : 240, nextHeight)
          ).toFixed(2);
          if (widthInput) widthInput.value = layer.dataset.width;
          updateLayerTransform(layer);
          updateDesignerProperties();
          return;
        }
        if (!dragState || dragState.layer !== layer) return;
        const x = ((event.clientX - dragState.offsetX - dragState.rect.left) / dragState.rect.width) * 100;
        const y = ((event.clientY - dragState.offsetY - dragState.rect.top) / dragState.rect.height) * 100;
        layer.dataset.x = Math.max(-80, Math.min(180, x)).toFixed(2);
        layer.dataset.y = Math.max(-80, Math.min(180, y)).toFixed(2);
        updateLayerTransform(layer);
        updateDesignerProperties();
      });
      layer.addEventListener('pointerup', () => {
        dragState = null;
        resizeState = null;
        rotateState = null;
      });
      layer.addEventListener('pointercancel', () => {
        dragState = null;
        resizeState = null;
        rotateState = null;
      });
      surface.appendChild(layer);
      updateLayerStack();
      selectLayer(layer);
      updateLayerTransform(layer);
      return layer;
    };

    const addLayerHandles = (layer) => {
      if (layer.dataset.directEditable !== 'true') return;
      if (layer.querySelector('.designer-resize-handle')) return;
      const rotateHandle = document.createElement('button');
      rotateHandle.type = 'button';
      rotateHandle.className = 'designer-rotate-handle';
      rotateHandle.setAttribute('aria-label', 'Rotate uploaded image');
      const handle = document.createElement('button');
      handle.type = 'button';
      handle.className = 'designer-resize-handle';
      handle.setAttribute('aria-label', 'Resize uploaded image proportionally');
      layer.appendChild(rotateHandle);
      layer.appendChild(handle);
    };

    const layerText = (layer) => {
      const content = layer.querySelector('.designer-layer-content');
      return content ? content.textContent.trim() : (layer.dataset.text || '');
    };

    const uppercaseDesignText = (value) => {
      return String(value || '').toUpperCase();
    };

    const presetPalette = {
      sunset: ['#ff8a33', '#ffdf70', '#ff5c89'],
      pink: ['#fb54d8', '#ffc0ef', '#bf42ff'],
      rose: ['#ff4568', '#ff9baa', '#d21f4d'],
      confetti: ['#3156ff', '#ff49d1', '#35e6ff'],
      violet: ['#7e4dff', '#d2c1ff', '#4c31d8'],
      blue: ['#28a8ff', '#a8e8ff', '#1476d4'],
      smoke: ['#dadada', '#f6f6f6', '#a6a6a6'],
      pastel: ['#ffe3c7', '#c9f3dc', '#f8bbd8'],
      rainbow: ['#ff6a6a', '#4ecbff', '#ffdf4e'],
      orange: ['#ff4c28', '#ffb235', '#ffec8a'],
      green: ['#35d64f', '#b8ff94', '#00a86b']
    };

    const createVintageBackground = (preset) => {
      const colors = presetPalette[preset] || presetPalette.sunset;
      const canvas = document.createElement('canvas');
      canvas.width = 900;
      canvas.height = 620;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const blobs = [
        [260, 260, 230, colors[0], .72],
        [455, 220, 245, colors[1], .62],
        [590, 335, 230, colors[2], .68],
        [375, 420, 180, colors[0], .38],
        [520, 455, 170, colors[2], .36]
      ];
      blobs.forEach(([x, y, radius, color, alpha]) => {
        const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
        gradient.addColorStop(0, color);
        gradient.addColorStop(.45, color);
        gradient.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.globalAlpha = alpha;
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.globalAlpha = .82;
      for (let i = 0; i < 260; i += 1) {
        ctx.fillStyle = colors[i % colors.length];
        ctx.beginPath();
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1 + Math.random() * 3.5, 0, Math.PI * 2);
        ctx.fill();
      }
      return canvas.toDataURL('image/png');
    };

    const ensureBackgroundLayer = (preset, imageSrc = '') => {
      enterEditMode();
      const existing = surface.querySelector('[data-preset-background="true"]');
      if (preset === 'none') {
        existing?.remove();
        activeLayer = getLayers()[0] || null;
        updateLayerStack();
        updateLayerPanel();
        updateDesignerProperties();
        return;
      }
      const previousLayer = activeLayer;
      const src = imageSrc || createVintageBackground(preset);
      const box = printAreaLayerBox();
      const layer = existing || makeLayer('image');
      layer.dataset.presetBackground = 'true';
      layer.dataset.name = 'Background';
      layer.dataset.fileName = `Vintage ${preset}`;
      layer.dataset.x = String(box.x);
      layer.dataset.y = String(box.backgroundY);
      layer.dataset.width = String(box.width);
      layer.dataset.height = String(box.backgroundHeight);
      layer.dataset.scale = '100';
      layer.dataset.rotate = '0';
      layer.dataset.borderWidth = '0';
      layer.dataset.borderColor = '#000000';
      layer.innerHTML = '';
      const content = document.createElement('span');
      content.className = 'designer-layer-content';
      const image = document.createElement('img');
      image.alt = `Vintage ${preset}`;
      image.addEventListener('load', () => fitImageLayerBoxToImage(layer, image), { once: true });
      image.src = src;
      content.appendChild(image);
      layer.appendChild(content);
      surface.appendChild(layer);
      updateLayerTransform(layer);
      updateLayerStack();
      if (previousLayer && previousLayer.isConnected) {
        selectLayer(previousLayer);
      } else {
        selectLayer(layer);
      }
      updateLayerPanel();
      updateDesignerProperties();
    };

    const textStyleConfig = (styleName, color = '#000000') => {
      const styles = {
        galaxy: {
          color: color || '#58d8ff',
          borderColor: '#fff36a',
          gradient: 'linear-gradient(180deg, #ff32ee 0%, #c52cff 24%, #6573ff 58%, #19e4ff 100%)',
          shadow: '0 2px 0 #11152e, 0 0 2px #fff, 0 0 8px rgba(255,240,80,.9), 4px 6px 0 rgba(12,18,35,.9)',
          font: "'Anduvu Bodoni 72 Smallcaps', 'Bodoni 72 Smallcaps', Bodoni, Didot, Georgia, serif",
          weight: '400',
          aspect: 385 / 900,
          warp: 'arch'
        },
        pink: {
          color: color || '#d819bd',
          borderColor: '#ffffff',
          gradient: 'linear-gradient(180deg, #180629 0%, #6e087f 23%, #ff20d8 52%, #b111c3 73%, #370348 100%)',
          shadow: '0 2px 0 #18001f, 0 0 2px #fff, 0 0 7px rgba(255,255,255,.9), 5px 7px 0 rgba(28,28,28,.92)',
          font: "'Anduvu Bodoni 72 Smallcaps', 'Bodoni 72 Smallcaps', Bodoni, Didot, Georgia, serif",
          weight: '400',
          aspect: 387 / 900,
          warp: 'arch'
        },
        gold: {
          color: color || '#f4a21f',
          borderColor: '#fff06a',
          gradient: 'linear-gradient(105deg, #8e3508 0%, #df7414 20%, #ffbd32 43%, #fff335 64%, #e78315 82%, #ffcf35 100%)',
          shadow: '0 2px 0 #6d3100, 0 0 2px #fff36a, 0 0 7px rgba(255,220,38,.9), 5px 7px 0 rgba(55,35,0,.82)',
          font: "'Anduvu Butler ExtraBold', 'Butler FREE VERSION ExtraBold', Butler, Georgia, serif",
          weight: '900',
          aspect: 342 / 900,
          warp: 'bulge'
        },
        blue: {
          color: color || '#2378bd',
          borderColor: '#ffffff',
          shadow: '0 2px 0 #123f68, 0 0 7px rgba(255,255,255,.8)',
          font: "Impact, 'Arial Black', Arial, sans-serif"
        },
        silver: {
          color: color || '#777777',
          borderColor: '#ffffff',
          shadow: '0 2px 0 #333, 0 0 8px rgba(255,255,255,.85)',
          font: "Impact, 'Arial Black', Arial, sans-serif"
        },
        bronze: {
          color: color || '#b8860b',
          borderColor: '#ffe09b',
          shadow: '0 2px 0 #573600, 0 0 7px rgba(255,255,255,.8)',
          font: "Georgia, 'Times New Roman', serif"
        }
      };
      return styles[styleName] || styles.blue;
    };

    const customPresetFontCache = new Map();

    const ensureCustomPresetFont = (styleName, fontUrl, fallbackFont) => {
      const normalizedUrl = String(fontUrl || '').trim();
      if (!normalizedUrl) return null;
      const cacheKey = `${styleName}:${normalizedUrl}`;
      if (customPresetFontCache.has(cacheKey)) return customPresetFontCache.get(cacheKey);
      let hash = 2166136261;
      for (let index = 0; index < normalizedUrl.length; index += 1) {
        hash ^= normalizedUrl.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
      }
      const family = `AnduvuPreset${styleName || 'Text'}${(hash >>> 0).toString(36)}`;
      const record = {
        family,
        cssFamily: `"${family}", ${fallbackFont || 'Georgia, serif'}`,
        ready: Promise.resolve(false)
      };
      if (typeof FontFace === 'function' && document.fonts) {
        const face = new FontFace(family, `url(${JSON.stringify(normalizedUrl)})`);
        record.ready = face.load()
          .then((loadedFace) => {
            document.fonts.add(loadedFace);
            return true;
          })
          .catch((error) => {
            console.warn('ANDUVU custom font fallback:', error);
            return false;
          });
      }
      customPresetFontCache.set(cacheKey, record);
      return record;
    };

    const applyTextVisualStyle = (layer) => {
      if (!layer || layer.dataset.type !== 'text') return;
      const config = textStyleConfig(layer.dataset.textStyle || '', layer.dataset.color || layer.style.color || '#000000');
      const content = layer.querySelector('.designer-layer-content');
      const selectedFont = layer.dataset.font || config.font;
      layer.dataset.textWarp = config.warp || '';
      layer.dataset.font = selectedFont;
      layer.dataset.weight = config.weight || layer.dataset.weight || '900';
      layer.style.fontFamily = selectedFont;
      layer.style.fontWeight = layer.dataset.weight;
      layer.style.color = config.color;
      layer.style.textShadow = config.shadow;
      layer.style.webkitTextStroke = `${Math.max(1, Number(layer.dataset.borderWidth || 0))}px ${layer.dataset.borderColor || config.borderColor}`;
      layer.style.WebkitTextStroke = `${Math.max(1, Number(layer.dataset.borderWidth || 0))}px ${layer.dataset.borderColor || config.borderColor}`;
      if (content) {
        const letterSpacing = Number.parseFloat(layer.dataset.textLetterSpacing || '0');
        content.style.fontFamily = selectedFont;
        content.style.letterSpacing = `${Number.isFinite(letterSpacing) ? letterSpacing / 100 : 0}em`;
        content.style.backgroundImage = config.gradient || 'none';
        content.style.backgroundClip = config.gradient ? 'text' : '';
        content.style.webkitBackgroundClip = config.gradient ? 'text' : '';
        content.style.webkitTextFillColor = config.gradient ? 'transparent' : '';
        content.style.filter = `drop-shadow(0 0 1px ${config.borderColor}) drop-shadow(3px 5px 0 rgba(20,20,20,.72))`;
      }
    };

    // Keep every personalized word locked to the configured text frame. This is
    // intentionally a horizontal fit: even a single glyph fills the frame while
    // the frame height, preset warp and the customer's layout remain unchanged.
    const fitTextToFrame = (layer) => {
      if (!layer || layer.dataset.type !== 'text') return;
      const content = layer.querySelector('.designer-layer-content');
      if (!content) return;
      content.style.setProperty('--designer-text-fit-x', '1');
      content.style.setProperty('--designer-text-fit-y', '1');
      const availableWidth = Math.max(1, layer.clientWidth * .94);
      const availableHeight = Math.max(1, layer.clientHeight * .86);
      const measuredWidth = Math.max(1, content.scrollWidth || content.getBoundingClientRect().width);
      const measuredHeight = Math.max(1, content.scrollHeight || content.getBoundingClientRect().height);
      const fitX = Math.max(.05, Math.min(24, availableWidth / measuredWidth));
      const fitY = Math.max(.05, Math.min(1, availableHeight / measuredHeight));
      content.style.setProperty('--designer-text-fit-x', fitX.toFixed(4));
      content.style.setProperty('--designer-text-fit-y', fitY.toFixed(4));
      layer.dataset.textFitX = fitX.toFixed(4);
      layer.dataset.textFitY = fitY.toFixed(4);
    };

    const queueTextFit = (layer) => {
      window.requestAnimationFrame(() => fitTextToFrame(layer));
    };

    const findTextLayerByRole = (role) => getLayers().find((layer) => layer.dataset.type === 'text' && layer.dataset.textRole === role);

    const applyTextPreset = (color, styleName = '', targetRole = '', frameSrc = '', frameAspect = '', letterSpacing = '', fontUrl = '') => {
      enterEditMode();
      if (targetRole) {
        const enabledInput = section.querySelector(`[data-text-enabled="${targetRole}"]`);
        if (enabledInput) {
          enabledInput.checked = true;
          enabledInput.closest('[data-preset-section]')?.classList.remove('is-disabled');
        }
      }
      let target = targetRole ? findTextLayerByRole(targetRole) : null;
      if (!target) target = activeLayer?.dataset.type === 'text' ? activeLayer : getLayers().find((layer) => layer.dataset.type === 'text');
      if (!target) {
        const box = printAreaLayerBox();
        applyText({
          value: 'CUSTOM',
          role: targetRole,
          textStyle: styleName,
          width: box.width,
          x: box.x,
          y: targetRole === 'bottom' ? box.bottomTextY : box.topTextY
        });
        target = activeLayer;
      }
      selectLayer(target);
      const config = textStyleConfig(styleName, color);
      if (colorInput) colorInput.value = color;
      if (borderWidthInput) borderWidthInput.value = Math.max(Number(borderWidthInput.value || 0), 1);
      if (borderColorInput) borderColorInput.value = config.borderColor;
      if (fontSelect) fontSelect.value = config.font;
      if (boldButton) boldButton.setAttribute('aria-pressed', 'true');
      target.dataset.borderWidth = borderWidthInput?.value || '1';
      target.dataset.borderColor = borderColorInput?.value || config.borderColor;
      target.dataset.color = color;
      target.dataset.textStyle = styleName || '';
      target.dataset.textRole = targetRole || target.dataset.textRole || '';
      const normalizedLetterSpacing = Number.parseFloat(letterSpacing || '0');
      target.dataset.textLetterSpacing = Number.isFinite(normalizedLetterSpacing) ? String(normalizedLetterSpacing) : '0';
      const uploadedFrameAspect = Number.parseFloat(frameAspect || '');
      if (frameSrc) {
        target.dataset.textFrame = frameSrc;
        if (Number.isFinite(uploadedFrameAspect) && uploadedFrameAspect > 0) {
          target.dataset.textFrameRatio = (1 / uploadedFrameAspect).toFixed(6);
        }
      } else {
        delete target.dataset.textFrame;
        delete target.dataset.textFrameRatio;
      }
      if (config.aspect) {
        target.dataset.height = (Number(target.dataset.width || 34) * config.aspect).toFixed(3);
      }
      const customFont = ensureCustomPresetFont(styleName, fontUrl, config.font);
      if (customFont) {
        target.dataset.textFontUrl = String(fontUrl).trim();
        target.dataset.font = customFont.cssFamily;
        target._anduvuFontReady = customFont.ready;
      } else {
        delete target.dataset.textFontUrl;
        target.dataset.font = config.font;
        target._anduvuFontReady = null;
      }
      updateActiveTextStyle();
      if (customFont) {
        target.dataset.font = customFont.cssFamily;
        applyTextVisualStyle(target);
        queueTextFit(target);
        customFont.ready.then((loaded) => {
          if (!loaded || !target.isConnected || target.dataset.textFontUrl !== String(fontUrl).trim()) return;
          target.dataset.font = customFont.cssFamily;
          applyTextVisualStyle(target);
          queueTextFit(target);
          updateDesignerProperties();
          scheduleAutoRender();
        });
      }
      syncFixedTemplateLayout();
    };

    const autoRenderDefaultTemplate = () => {
      if (didRenderDefaultTemplate) return;
      didRenderDefaultTemplate = true;
      window.setTimeout(async () => {
        if (renderedPreviews.length) return;
        const render = await renderDesigner({ upload: false });
        addRenderedPreview(render);
      }, 250);
    };

    const applyDefaultTemplate = () => {
      const box = printAreaLayerBox();
      const defaultTextButton = Array.from(textPresetButtons).find((button) => button.dataset.textStyle === 'gold') || textPresetButtons[0];
      const defaultFrameAspect = Number.parseFloat(defaultTextButton?.dataset.textFrameAspect || '');
      const defaultFrameRatio = Number.isFinite(defaultFrameAspect) && defaultFrameAspect > 0 ? 1 / defaultFrameAspect : 342 / 900;
      const defaultTextConfig = textStyleConfig('gold', '#f4a21f');
      const defaultCustomFont = ensureCustomPresetFont('gold', defaultTextButton?.dataset.textFontUrl || '', defaultTextConfig.font);
      applyText({
        value: 'CUSTOM',
        role: 'top',
        textStyle: 'gold',
        font: defaultCustomFont?.cssFamily || defaultTextConfig.font,
        color: '#f4a21f',
        fontSize: 54,
        width: box.width,
        height: box.width * defaultFrameRatio,
        x: box.x,
        y: box.topTextY,
        borderWidth: 2,
        borderColor: '#fff06a',
        weight: '900',
        textFrame: defaultTextButton?.dataset.textFrame || '',
        textFrameRatio: defaultTextButton?.dataset.textFrame ? defaultFrameRatio : '',
        textLetterSpacing: defaultTextButton?.dataset.textLetterSpacing || '-6',
        textFontUrl: defaultTextButton?.dataset.textFontUrl || ''
      });
      if (defaultCustomFont && activeLayer?.dataset.type === 'text') {
        const defaultLayer = activeLayer;
        defaultLayer._anduvuFontReady = defaultCustomFont.ready;
        defaultCustomFont.ready.then((loaded) => {
          if (!loaded || !defaultLayer.isConnected) return;
          defaultLayer.dataset.font = defaultCustomFont.cssFamily;
          applyTextVisualStyle(defaultLayer);
          queueTextFit(defaultLayer);
          updateDesignerProperties();
          scheduleAutoRender();
        });
      }
      const defaultBgButton = Array.from(bgPresetButtons).find((button) => button.classList.contains('is-selected')) || bgPresetButtons[0];
      ensureBackgroundLayer(defaultBgButton?.dataset.bgPreset || 'cloud-galaxy', defaultBgButton?.dataset.bgImage || '');
      bgPresetButtons.forEach((button) => button.classList.toggle('is-selected', button === defaultBgButton));
      textPresetButtons.forEach((button) => button.classList.toggle('is-selected', button.dataset.textStyle === 'gold'));
      autoRenderDefaultTemplate();
    };

    const applyText = (options = {}) => {
      enterEditMode();
      const hasExplicitValue = Object.prototype.hasOwnProperty.call(options, 'value');
      const sourceValue = hasExplicitValue ? options.value : (textInput ? textInput.value : 'CUSTOM');
      const value = uppercaseDesignText(sourceValue ?? '');
      const layer = makeLayer('text');
      layer.innerHTML = `<span class="designer-layer-content" aria-hidden="true"></span>`;
      const content = layer.querySelector('.designer-layer-content');
      content.textContent = value;
      content.addEventListener('input', () => {
        enterEditMode();
        const upper = uppercaseDesignText(content.textContent.trim() || '');
        if (content.textContent !== upper) {
          content.textContent = upper;
          const range = document.createRange();
          const selection = window.getSelection();
          range.selectNodeContents(content);
          range.collapse(false);
          selection?.removeAllRanges();
          selection?.addRange(range);
        }
        layer.dataset.text = upper;
        if (textInput) textInput.value = layer.dataset.text;
        if (customerTextInput) customerTextInput.value = layer.dataset.text;
        queueTextFit(layer);
        updateDesignerProperties();
      });
      content.addEventListener('focus', () => selectLayer(layer));
      layer.style.fontFamily = options.font || fontSelect?.value || 'Georgia, serif';
      layer.style.color = options.color || colorInput?.value || '#000000';
      layer.style.fontSize = `${options.fontSize || fontSizeInput?.value || 54}px`;
      layer.style.fontWeight = options.weight || (boldButton?.getAttribute('aria-pressed') === 'false' ? '400' : '900');
      layer.style.fontStyle = options.italic ? 'italic' : (italicButton?.getAttribute('aria-pressed') === 'true' ? 'italic' : 'normal');
      layer.dataset.text = value;
      layer.dataset.font = layer.style.fontFamily;
      layer.dataset.color = layer.style.color;
      layer.dataset.fontSize = String(options.fontSize || fontSizeInput?.value || '54');
      layer.dataset.weight = layer.style.fontWeight;
      layer.dataset.italic = layer.style.fontStyle === 'italic' ? 'true' : 'false';
      layer.dataset.textRole = options.role || layer.dataset.textRole || '';
      layer.dataset.textStyle = options.textStyle || layer.dataset.textStyle || '';
      if (options.textFrame) layer.dataset.textFrame = options.textFrame;
      if (options.textFrameRatio) layer.dataset.textFrameRatio = String(options.textFrameRatio);
      layer.dataset.textLetterSpacing = String(options.textLetterSpacing ?? layer.dataset.textLetterSpacing ?? '0');
      if (options.textFontUrl) layer.dataset.textFontUrl = String(options.textFontUrl);
      layer.dataset.width = String(options.width || widthInput?.value || '78');
      layer.dataset.height = String(options.height || layer.dataset.height || '34');
      layer.dataset.x = String(options.x || layer.dataset.x || '50');
      layer.dataset.y = String(options.y || layer.dataset.y || '42');
      layer.dataset.borderWidth = String(options.borderWidth ?? borderWidthInput?.value ?? '0');
      layer.dataset.borderColor = options.borderColor || borderColorInput?.value || '#000000';
      applyTextVisualStyle(layer);
      const firstLayer = surface.querySelector('.designer-layer');
      if (firstLayer && firstLayer !== layer) surface.insertBefore(layer, firstLayer);
      updateLayerStack();
      updateLayerTransform(layer);
      queueTextFit(layer);
      selectLayer(layer);
      if (textInput) textInput.value = value;
      if (customerTextInput) customerTextInput.value = value;
      updateLayerPanel();
      updateDesignerProperties();
    };

    const updateActiveTextStyle = () => {
      if (activeLayer?.dataset.type !== 'text') return;
      enterEditMode();
      const sourceValue = textInput ? textInput.value : (activeLayer.dataset.text ?? '');
      const value = uppercaseDesignText(sourceValue ?? '');
      const content = activeLayer.querySelector('.designer-layer-content');
      if (content) content.textContent = value;
      const nextText = value;
      if (textInput) textInput.value = nextText;
      if (customerTextInput) customerTextInput.value = nextText;
      const selectedFont = activeLayer.dataset.textFontUrl && activeLayer.dataset.font
        ? activeLayer.dataset.font
        : (fontSelect?.value || 'Georgia, serif');
      activeLayer.style.fontFamily = selectedFont;
      activeLayer.style.color = colorInput?.value || '#000000';
      activeLayer.style.fontSize = `${fontSizeInput?.value || activeLayer.dataset.fontSize || 54}px`;
      activeLayer.style.fontWeight = boldButton?.getAttribute('aria-pressed') === 'false' ? '400' : '900';
      activeLayer.style.fontStyle = italicButton?.getAttribute('aria-pressed') === 'true' ? 'italic' : 'normal';
      activeLayer.dataset.text = nextText;
      activeLayer.dataset.font = activeLayer.style.fontFamily;
      activeLayer.dataset.color = activeLayer.style.color;
      activeLayer.dataset.fontSize = fontSizeInput?.value || activeLayer.dataset.fontSize || '54';
      activeLayer.dataset.weight = activeLayer.style.fontWeight;
      activeLayer.dataset.italic = activeLayer.style.fontStyle === 'italic' ? 'true' : 'false';
      activeLayer.dataset.borderWidth = borderWidthInput?.value || activeLayer.dataset.borderWidth || '0';
      activeLayer.dataset.borderColor = borderColorInput?.value || activeLayer.dataset.borderColor || '#000000';
      applyTextVisualStyle(activeLayer);
      updateLayerTransform(activeLayer);
      queueTextFit(activeLayer);
      updateDesignerProperties();
    };

    const applyImageSrc = (src, name = 'Image template', options = {}) => {
      if (!src) return;
      enterEditMode();
      const layer = makeLayer('image');
      const isCustomerUpload = options.customerUpload === true;
      layer.dataset.customerUpload = isCustomerUpload ? 'true' : 'false';
      layer.dataset.directEditable = isCustomerUpload ? 'true' : 'false';
      layer.dataset.preserveAspect = isCustomerUpload ? 'true' : 'false';
      if (isCustomerUpload) {
        layer.dataset.originalMimeType = options.originalMimeType || '';
        layer.dataset.originalFileSize = String(options.originalFileSize || 0);
      }
      layer.tabIndex = isCustomerUpload ? 0 : -1;
      if (isCustomerUpload) {
        layer.setAttribute('role', 'group');
        layer.setAttribute('aria-label', 'Move, rotate, or resize uploaded image');
      }
      const content = document.createElement('span');
      content.className = 'designer-layer-content';
      const image = document.createElement('img');
      image.alt = name;
      image.addEventListener('load', () => fitImageLayerBoxToImage(layer, image), { once: true });
      image.src = src;
      layer.innerHTML = '';
      content.appendChild(image);
      layer.appendChild(content);
      layer.dataset.width = '46';
      layer.dataset.height = '34';
      layer.dataset.borderWidth = borderWidthInput?.value || '0';
      layer.dataset.borderColor = borderColorInput?.value || '#000000';
      addLayerHandles(layer);
      const backgroundLayer = surface.querySelector('[data-preset-background="true"]');
      if (backgroundLayer) surface.insertBefore(layer, backgroundLayer);
      updateLayerStack();
      updateLayerTransform(layer);
      layer.dataset.fileName = name;
      selectLayer(layer);
      updateLayerPanel();
      updateDesignerProperties();
      return layer;
    };

    const applyImageFile = (file) => {
      if (!(file instanceof File)) return;
      if (originalCustomerUploadUrl) URL.revokeObjectURL(originalCustomerUploadUrl);
      section._anduvuOriginalUploadFile = file;
      syncOriginalUploadToProductForm(file);
      originalCustomerUploadUrl = URL.createObjectURL(file);
      surface.querySelectorAll('[data-customer-upload="true"]').forEach((layer) => layer.remove());
      return applyImageSrc(originalCustomerUploadUrl, file.name, {
        customerUpload: true,
        originalMimeType: file.type,
        originalFileSize: file.size
      });
    };

    const updateDesignerProperties = () => {
      syncFixedTemplateLayout();
      const layers = getLayers().map((layer) => {
        const image = layer.querySelector('.designer-layer-content img');
        return {
          type: layer.dataset.type,
          text: layer.dataset.text || layerText(layer),
          fileName: layer.dataset.fileName || '',
          src: image?.currentSrc || image?.src || '',
          presetBackground: layer.dataset.presetBackground === 'true',
          customerUpload: layer.dataset.customerUpload === 'true',
          originalMimeType: layer.dataset.originalMimeType || '',
          originalFileSize: Number(layer.dataset.originalFileSize || 0),
          x: layer.dataset.x,
          y: layer.dataset.y,
          scale: layer.dataset.scale,
          rotate: layer.dataset.rotate,
          width: layer.dataset.width,
          height: layer.dataset.height,
          borderWidth: layer.dataset.borderWidth || '0',
          borderColor: layer.dataset.borderColor || '#000000',
          fontSize: layer.dataset.fontSize,
          weight: layer.dataset.weight,
          italic: layer.dataset.italic,
          textRole: layer.dataset.textRole || '',
          textStyle: layer.dataset.textStyle || '',
          textFrame: layer.dataset.textFrame || '',
          textFrameRatio: layer.dataset.textFrameRatio || '',
          textLetterSpacing: layer.dataset.textLetterSpacing || '0',
          textFontUrl: layer.dataset.textFontUrl || '',
          color: layer.dataset.color || layer.style.color || '',
          font: layer.dataset.font || layer.style.fontFamily || ''
        };
      });
      const textLayers = layers.filter((layer) => layer.type === 'text').map((layer) => layer.text).join(' | ');
      if (dataProperty) dataProperty.value = JSON.stringify({
        product: productSelect?.options[productSelect.selectedIndex]?.dataset.productTitle || '',
        variantId: variantInput?.value || '',
        size: sizeSelect?.value || '',
        shirtColor: shirtColorSelect?.value || '',
        printArea: currentPrintAreaData(),
        renderer: canRemoteRender ? 'External PHP ImageMagick render' : (canUploadToCloud ? 'Cloudinary unsigned upload' : 'Browser local render'),
        layers
      });
      if (textProperty) textProperty.value = textLayers;
      if (colorProperty) colorProperty.value = shirtColorSelect?.value || '';
      if (sizeProperty) sizeProperty.value = sizeSelect?.value || '';
      if (aiPromptProperty) {
        aiPromptProperty.value = [
          'Create a realistic product preview for print-on-demand approval.',
          'Do not change the customer design, text spelling, font style, placement, colors, product color, or uploaded image content.',
          'Only blend the provided transparent customer layers into the product mockup with natural fabric texture, light, shadow, and perspective.',
          'Return a clean preview image and keep a separate transparent production print file.'
        ].join(' ');
      }
    };

    const loadCanvasImage = (src) => {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = src;
      });
    };

    const textFrameProfileCache = new Map();

    const smoothFrameSeries = (values, radius = 3) => {
      return values.map((value, index) => {
        let sum = 0;
        let weight = 0;
        for (let offset = -radius; offset <= radius; offset += 1) {
          const sampleIndex = Math.max(0, Math.min(values.length - 1, index + offset));
          const sampleWeight = radius + 1 - Math.abs(offset);
          sum += values[sampleIndex] * sampleWeight;
          weight += sampleWeight;
        }
        return weight ? sum / weight : value;
      });
    };

    const fillFrameProfileGaps = (values) => {
      const filled = values.slice();
      let previous = -1;
      for (let index = 0; index < filled.length; index += 1) {
        if (filled[index] == null) continue;
        if (previous < 0) {
          for (let leading = 0; leading < index; leading += 1) filled[leading] = filled[index];
        } else if (index - previous > 1) {
          const start = filled[previous];
          const end = filled[index];
          for (let gap = previous + 1; gap < index; gap += 1) {
            const progress = (gap - previous) / (index - previous);
            filled[gap] = start + (end - start) * progress;
          }
        }
        previous = index;
      }
      if (previous >= 0) {
        for (let trailing = previous + 1; trailing < filled.length; trailing += 1) filled[trailing] = filled[previous];
      }
      return filled;
    };

    const analyzeTextFrame = (src) => {
      if (!src) return Promise.resolve(null);
      if (textFrameProfileCache.has(src)) return textFrameProfileCache.get(src);
      const analysis = (async () => {
        const image = await loadCanvasImage(src);
        const naturalWidth = image.naturalWidth || image.width || 0;
        const naturalHeight = image.naturalHeight || image.height || 0;
        if (!naturalWidth || !naturalHeight) throw new Error('The uploaded text frame has no readable dimensions.');
        const sampleWidth = Math.max(32, Math.min(512, naturalWidth));
        const sampleHeight = Math.max(8, Math.round((naturalHeight / naturalWidth) * sampleWidth));
        const canvas = document.createElement('canvas');
        canvas.width = sampleWidth;
        canvas.height = sampleHeight;
        const frameContext = canvas.getContext('2d', { willReadFrequently: true });
        frameContext.clearRect(0, 0, sampleWidth, sampleHeight);
        frameContext.drawImage(image, 0, 0, sampleWidth, sampleHeight);
        const pixels = frameContext.getImageData(0, 0, sampleWidth, sampleHeight).data;
        const top = new Array(sampleWidth).fill(null);
        const bottom = new Array(sampleWidth).fill(null);
        for (let x = 0; x < sampleWidth; x += 1) {
          for (let y = 0; y < sampleHeight; y += 1) {
            const alpha = pixels[((y * sampleWidth) + x) * 4 + 3];
            if (alpha < 24) continue;
            if (top[x] == null) top[x] = y;
            bottom[x] = y;
          }
        }
        const validColumns = top.map((value, index) => value != null && bottom[index] != null ? index : -1).filter((index) => index >= 0);
        if (validColumns.length < 8) throw new Error('The uploaded text frame needs a visible transparent-PNG shape across the canvas.');
        const first = validColumns[0];
        const last = validColumns[validColumns.length - 1];
        const filledTop = fillFrameProfileGaps(top.slice(first, last + 1));
        const filledBottom = fillFrameProfileGaps(bottom.slice(first, last + 1));
        const globalTop = Math.min(...filledTop);
        const globalBottom = Math.max(...filledBottom);
        const visibleHeight = Math.max(1, globalBottom - globalTop);
        const normalizedTop = smoothFrameSeries(filledTop.map((value) => (value - globalTop) / visibleHeight));
        const normalizedBottom = smoothFrameSeries(filledBottom.map((value) => (value - globalTop) / visibleHeight));
        normalizedBottom.forEach((value, index) => {
          normalizedTop[index] = Math.max(0, Math.min(.98, normalizedTop[index]));
          normalizedBottom[index] = Math.max(normalizedTop[index] + .02, Math.min(1, value));
        });
        return { top: normalizedTop, bottom: normalizedBottom };
      })().catch((error) => {
        console.warn('ANDUVU text frame fallback:', error);
        return null;
      });
      textFrameProfileCache.set(src, analysis);
      return analysis;
    };

    const cropTransparentCanvas = (source) => {
      const context = source.getContext('2d', { willReadFrequently: true });
      const width = source.width;
      const height = source.height;
      const pixels = context.getImageData(0, 0, width, height).data;
      let left = width;
      let right = -1;
      let top = height;
      let bottom = -1;
      for (let y = 0; y < height; y += 1) {
        for (let x = 0; x < width; x += 1) {
          if (pixels[((y * width) + x) * 4 + 3] < 4) continue;
          left = Math.min(left, x);
          right = Math.max(right, x);
          top = Math.min(top, y);
          bottom = Math.max(bottom, y);
        }
      }
      if (right < left || bottom < top) return source;
      const padding = 2;
      left = Math.max(0, left - padding);
      right = Math.min(width - 1, right + padding);
      top = Math.max(0, top - padding);
      bottom = Math.min(height - 1, bottom + padding);
      const cropped = document.createElement('canvas');
      cropped.width = Math.max(1, right - left + 1);
      cropped.height = Math.max(1, bottom - top + 1);
      cropped.getContext('2d').drawImage(source, left, top, cropped.width, cropped.height, 0, 0, cropped.width, cropped.height);
      return cropped;
    };

    const sampleTextFrameEdge = (values, progress) => {
      const position = Math.max(0, Math.min(1, progress)) * (values.length - 1);
      const left = Math.floor(position);
      const right = Math.min(values.length - 1, left + 1);
      const mix = position - left;
      return values[left] + (values[right] - values[left]) * mix;
    };

    // Warp one complete, alpha-padded glyph bitmap through its own frame
    // segment. The source height is never cropped per column, so serifs,
    // outlines, shadows and highlights remain intact while the glyph's outer
    // bitmap is pulled toward the configured top and bottom edges.
    const drawCanvasThroughTextFrame = (targetContext, source, frameProfile, width, height, centerY = 0, start = 0, end = 1) => {
      if (!source?.width || !source?.height || !frameProfile?.top?.length) return false;
      const safeStart = Math.max(.025, Math.min(.975, start));
      const safeEnd = Math.max(safeStart + .002, Math.min(.975, end));
      const slices = Math.max(12, Math.min(120, Math.round(source.width / 2)));
      for (let index = 0; index < slices; index += 1) {
        const sourceStart = Math.floor((index / slices) * source.width);
        const sourceEnd = Math.min(source.width, Math.max(sourceStart + 1, Math.ceil(((index + 1) / slices) * source.width)));
        const sliceStart = safeStart + (index / slices) * (safeEnd - safeStart);
        const sliceEnd = safeStart + ((index + 1) / slices) * (safeEnd - safeStart);
        const topEdge = sampleTextFrameEdge(frameProfile.top, (sliceStart + sliceEnd) / 2);
        const bottomEdge = sampleTextFrameEdge(frameProfile.bottom, (sliceStart + sliceEnd) / 2);
        const destinationX = -width / 2 + sliceStart * width;
        const destinationWidth = (sliceEnd - sliceStart) * width + .75;
        const destinationY = centerY - height / 2 + topEdge * height;
        const destinationHeight = Math.max(1, (bottomEdge - topEdge) * height);
        targetContext.drawImage(
          source,
          sourceStart,
          0,
          Math.max(1, sourceEnd - sourceStart),
          source.height,
          destinationX,
          destinationY,
          destinationWidth,
          destinationHeight
        );
      }
      return true;
    };

    const resetUsableArea = () => {
      const left = Number(section.dataset.printAreaLeft || 31);
      const top = Number(section.dataset.printAreaTop || 29);
      const width = Number(section.dataset.printAreaWidth || 38);
      const height = Number(section.dataset.printAreaHeight || 57);
      Object.assign(printArea.style, {
        left: `${left}%`,
        top: `${top}%`,
        right: 'auto',
        bottom: 'auto',
        width: `${width}%`,
        height: `${height}%`
      });
    };

    const syncUsableArea = async () => {
      resetUsableArea();
      return;
      const src = productImage?.currentSrc || productImage?.src || baseProductImageSrc || '';
      if (!/(\.png(?:\?|$)|data:image\/png|format=png)/i.test(src)) return;
      try {
        const image = await loadCanvasImage(src);
        const canvas = document.createElement('canvas');
        const naturalWidth = image.naturalWidth || image.width;
        const naturalHeight = image.naturalHeight || image.height;
        const sampleWidth = 420;
        const sampleHeight = Math.max(1, Math.round((naturalHeight / naturalWidth) * sampleWidth));
        canvas.width = sampleWidth;
        canvas.height = sampleHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, sampleWidth, sampleHeight);
        const pixels = ctx.getImageData(0, 0, sampleWidth, sampleHeight).data;
        let minX = sampleWidth;
        let minY = sampleHeight;
        let maxX = 0;
        let maxY = 0;
        let found = false;
        for (let y = 0; y < sampleHeight; y += 1) {
          for (let x = 0; x < sampleWidth; x += 1) {
            const alpha = pixels[((y * sampleWidth + x) * 4) + 3];
            if (alpha > 24) {
              found = true;
              if (x < minX) minX = x;
              if (y < minY) minY = y;
              if (x > maxX) maxX = x;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (!found) return;
        const pad = 2;
        minX = Math.max(0, minX - pad);
        minY = Math.max(0, minY - pad);
        maxX = Math.min(sampleWidth, maxX + pad);
        maxY = Math.min(sampleHeight, maxY + pad);
        const widthPct = ((maxX - minX) / sampleWidth) * 100;
        const heightPct = ((maxY - minY) / sampleHeight) * 100;
        if (widthPct < 12 || heightPct < 12 || widthPct > 99.5 || heightPct > 99.5) return;
        Object.assign(printArea.style, {
          left: `${(minX / sampleWidth) * 100}%`,
          top: `${(minY / sampleHeight) * 100}%`,
          right: 'auto',
          bottom: 'auto',
          width: `${widthPct}%`,
          height: `${heightPct}%`
        });
      } catch {
        resetUsableArea();
      }
    };

    const applyPrintAreaData = (area) => {
      Object.assign(printArea.style, {
        left: `${Math.max(0, Math.min(98, area.left))}%`,
        top: `${Math.max(0, Math.min(98, area.top))}%`,
        right: 'auto',
        bottom: 'auto',
        width: `${Math.max(12, Math.min(100 - area.left, area.width))}%`,
        height: `${Math.max(12, Math.min(100 - area.top, area.height))}%`
      });
      syncFixedTemplateLayout();
      updateDesignerProperties();
    };

    printArea.addEventListener('pointerdown', (event) => {
      if (event.target !== printArea) return;
      if (surface?.classList.contains('is-rendered')) return;
      const surfaceRect = surface.getBoundingClientRect();
      const area = currentPrintAreaData();
      areaDragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        surfaceWidth: Math.max(1, surfaceRect.width),
        surfaceHeight: Math.max(1, surfaceRect.height),
        area
      };
      printArea.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    printAreaResizeHandles.forEach((handle) => {
      handle.addEventListener('pointerdown', (event) => {
        if (surface?.classList.contains('is-rendered')) return;
        const surfaceRect = surface.getBoundingClientRect();
        const area = currentPrintAreaData();
        areaResizeState = {
          pointerId: event.pointerId,
          direction: handle.dataset.printAreaResize || 'se',
          startX: event.clientX,
          startY: event.clientY,
          surfaceWidth: Math.max(1, surfaceRect.width),
          surfaceHeight: Math.max(1, surfaceRect.height),
          area
        };
        handle.setPointerCapture(event.pointerId);
        event.preventDefault();
        event.stopPropagation();
      });
    });

    window.addEventListener('pointermove', (event) => {
      if (areaDragState) {
        const dx = ((event.clientX - areaDragState.startX) / areaDragState.surfaceWidth) * 100;
        const dy = ((event.clientY - areaDragState.startY) / areaDragState.surfaceHeight) * 100;
        applyPrintAreaData({
          ...areaDragState.area,
          left: areaDragState.area.left + dx,
          top: areaDragState.area.top + dy
        });
      }
      if (areaResizeState) {
        const dx = ((event.clientX - areaResizeState.startX) / areaResizeState.surfaceWidth) * 100;
        const dy = ((event.clientY - areaResizeState.startY) / areaResizeState.surfaceHeight) * 100;
        const nextArea = { ...areaResizeState.area };
        if (areaResizeState.direction === 'nw') {
          nextArea.left = areaResizeState.area.left + dx;
          nextArea.top = areaResizeState.area.top + dy;
          nextArea.width = areaResizeState.area.width - dx;
          nextArea.height = areaResizeState.area.height - dy;
        } else {
          nextArea.width = areaResizeState.area.width + dx;
          nextArea.height = areaResizeState.area.height + dy;
        }
        applyPrintAreaData(nextArea);
      }
    });

    window.addEventListener('pointerup', () => {
      areaDragState = null;
      areaResizeState = null;
    });

    const prepareImageLayerForPrint = (image) => {
      const canvas = document.createElement('canvas');
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, width, height);
      try {
        const imageData = ctx.getImageData(0, 0, width, height);
        const data = imageData.data;
        const samplePoints = [
          [0, 0],
          [width - 1, 0],
          [0, height - 1],
          [width - 1, height - 1]
        ];
        const bg = samplePoints.reduce((acc, [x, y]) => {
          const idx = ((y * width) + x) * 4;
          acc[0] += data[idx];
          acc[1] += data[idx + 1];
          acc[2] += data[idx + 2];
          return acc;
        }, [0, 0, 0]).map((value) => value / samplePoints.length);
        for (let i = 0; i < data.length; i += 4) {
          const distance = Math.hypot(data[i] - bg[0], data[i + 1] - bg[1], data[i + 2] - bg[2]);
          if (distance < 26) {
            data[i + 3] = 0;
          } else if (distance < 58) {
            data[i + 3] = Math.min(data[i + 3], Math.round((distance - 26) / 32 * 255));
          }
        }
        ctx.putImageData(imageData, 0, 0);
      } catch {
        return image;
      }
      return canvas;
    };

    const applyFabricBlend = (ctx, canvasSize) => {
      ctx.save();
      ctx.globalCompositeOperation = 'source-atop';
      ctx.globalAlpha = .13;
      ctx.fillStyle = '#000';
      for (let x = 0; x < canvasSize; x += 7) {
        ctx.fillRect(x, 0, 1, canvasSize);
      }
      ctx.globalAlpha = .11;
      const shadow = ctx.createLinearGradient(0, 0, canvasSize, canvasSize);
      shadow.addColorStop(0, 'rgba(255,255,255,.45)');
      shadow.addColorStop(.52, 'rgba(0,0,0,.38)');
      shadow.addColorStop(1, 'rgba(255,255,255,.28)');
      ctx.fillStyle = shadow;
      ctx.fillRect(0, 0, canvasSize, canvasSize);
      ctx.restore();
    };

    const uploadDataUrlToCloudinary = async (dataUrl, folder, publicId) => {
      if (!canUploadToCloud) return '';
      const body = new FormData();
      body.append('file', dataUrl);
      body.append('upload_preset', cloudinaryPreset);
      body.append('folder', folder);
      body.append('public_id', publicId);
      const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudinaryCloud}/image/upload`, {
        method: 'POST',
        body
      });
      if (!response.ok) {
        throw new Error(`Cloudinary upload failed: ${response.status}`);
      }
      const payload = await response.json();
      return payload.secure_url || payload.url || '';
    };

    const renderWithRemoteService = async ({ previewDataUrl, productionDataUrl }) => {
      if (!canRemoteRender) return {};
      const body = new FormData();
      body.append('design_json', dataProperty?.value || '{}');
      body.append('preview_data_url', previewDataUrl);
      body.append('production_data_url', productionDataUrl);
      body.append('mockup_url', baseProductImageSrc || productImage?.currentSrc || productImage?.src || '');
      body.append('product_title', productSelect?.options[productSelect.selectedIndex]?.dataset.productTitle || '');
      body.append('variant_id', variantInput?.value || '');
      body.append('size', sizeSelect?.value || '');
      body.append('shirt_color', shirtColorSelect?.value || '');
      body.append('quantity', quantityInput?.value || '1');
      const response = await fetch(renderServiceUrl, {
        method: 'POST',
        body
      });
      if (!response.ok) throw new Error(`Render service failed: ${response.status}`);
      const payload = await response.json();
      if (payload.error) throw new Error(payload.error);
      return payload;
    };

    const renderDesigner = async ({ upload = false } = {}) => {
      const renderRevision = editRevision;
      setRenderingState(true);
      try {
        const pendingCustomFonts = getLayers().map((layer) => layer._anduvuFontReady).filter(Boolean);
        if (pendingCustomFonts.length) await Promise.allSettled(pendingCustomFonts);
        if (document.fonts?.ready) {
          await document.fonts.ready;
          await Promise.all([
            document.fonts.load('900 64px "Anduvu Butler ExtraBold"'),
            document.fonts.load('900 64px "Anduvu Bodoni 72 Smallcaps"')
          ]);
        }
        setDesignerStatus(upload && canUploadDesignFiles ? 'Rendering and saving design files...' : 'Rendering final preview...');
        updateDesignerProperties();
        const size = 1400;
        const originalCustomerLayer = surface.querySelector('.designer-layer[data-customer-upload="true"]');
        const previewCanvas = document.createElement('canvas');
        previewCanvas.width = size;
        previewCanvas.height = size;
        const preview = previewCanvas.getContext('2d');
        const previewDesignCanvas = document.createElement('canvas');
        previewDesignCanvas.width = size;
        previewDesignCanvas.height = size;
        const previewDesign = previewDesignCanvas.getContext('2d');
        const displayCanvas = originalCustomerLayer ? document.createElement('canvas') : null;
        const displayDesignCanvas = originalCustomerLayer ? document.createElement('canvas') : null;
        const foregroundCanvas = originalCustomerLayer ? document.createElement('canvas') : null;
        if (displayCanvas) {
          displayCanvas.width = size;
          displayCanvas.height = size;
        }
        if (displayDesignCanvas) {
          displayDesignCanvas.width = size;
          displayDesignCanvas.height = size;
        }
        if (foregroundCanvas) {
          foregroundCanvas.width = size;
          foregroundCanvas.height = size;
        }
        const display = displayCanvas?.getContext('2d') || null;
        const displayDesign = displayDesignCanvas?.getContext('2d') || null;
        const foreground = foregroundCanvas?.getContext('2d') || null;
        const productionCanvas = document.createElement('canvas');
        productionCanvas.width = 1800;
        productionCanvas.height = 1800;
        const production = productionCanvas.getContext('2d');

        const drawContainedImage = (ctx, image, canvasSize) => {
          const ratio = Math.min(canvasSize / image.naturalWidth, canvasSize / image.naturalHeight);
          const width = image.naturalWidth * ratio;
          const height = image.naturalHeight * ratio;
          const x = (canvasSize - width) / 2;
          const y = (canvasSize - height) / 2;
          ctx.fillStyle = '#fff';
          ctx.fillRect(0, 0, canvasSize, canvasSize);
          ctx.drawImage(image, x, y, width, height);
        };

        const baseImage = baseProductImageSrc || productImage?.currentSrc || productImage?.src;
        if (baseImage) {
          try {
            const image = await loadCanvasImage(baseImage);
            drawContainedImage(preview, image, size);
            if (display) drawContainedImage(display, image, size);
          } catch {
            preview.fillStyle = '#fff';
            preview.fillRect(0, 0, size, size);
            if (display) {
              display.fillStyle = '#fff';
              display.fillRect(0, 0, size, size);
            }
          }
        }

        const surfaceRect = surface.getBoundingClientRect();
        const areaRect = printArea.getBoundingClientRect();
        const area = {
          x: ((areaRect.left - surfaceRect.left) / surfaceRect.width) * size,
          y: ((areaRect.top - surfaceRect.top) / surfaceRect.height) * size,
          width: (areaRect.width / surfaceRect.width) * size,
          height: (areaRect.height / surfaceRect.height) * size
        };

        const drawLayer = async (ctx, layer, productionMode = false) => {
          const x = Number(layer.dataset.x || 50) / 100;
          const y = Number(layer.dataset.y || 50) / 100;
          const layerScale = Number(layer.dataset.scale || 100) / 100;
          const rotate = Number(layer.dataset.rotate || 0) * Math.PI / 180;
          const layerRect = layer.getBoundingClientRect();
          const box = productionMode
            ? { x: 0, y: 0, width: productionCanvas.width, height: productionCanvas.height }
            : { x: 0, y: 0, width: size, height: size };
          const cx = box.x + box.width * x;
          const cy = box.y + box.height * y;
          ctx.save();
          if (layer.dataset.customerUpload === 'true') {
            const clipArea = productionMode
              ? {
                  x: (area.x / size) * productionCanvas.width,
                  y: (area.y / size) * productionCanvas.height,
                  width: (area.width / size) * productionCanvas.width,
                  height: (area.height / size) * productionCanvas.height
                }
              : area;
            ctx.beginPath();
            ctx.rect(clipArea.x, clipArea.y, clipArea.width, clipArea.height);
            ctx.clip();
          }
          ctx.translate(cx, cy);
          ctx.rotate(rotate);
          if (layer.dataset.type === 'text') {
            const text = layer.dataset.text || layerText(layer);
            const style = window.getComputedStyle(layer);
            const surfaceScale = size / Math.max(1, surfaceRect.width);
            const productionScale = productionCanvas.width / Math.max(1, surfaceRect.width);
            const fontPx = (parseFloat(style.fontSize) || 54) * (productionMode ? productionScale : surfaceScale) * layerScale;
            const fontWeight = layer.dataset.weight || style.fontWeight || '900';
            const fontStyle = layer.dataset.italic === 'true' ? 'italic' : (style.fontStyle || 'normal');
            ctx.fillStyle = layer.dataset.color || colorInput?.value || '#000';
            ctx.strokeStyle = layer.dataset.borderColor || '#000';
            ctx.lineWidth = Number(layer.dataset.borderWidth || 0) * (productionMode ? 4 : surfaceScale);
            ctx.lineJoin = 'round';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = `${fontStyle} ${fontWeight} ${fontPx}px ${layer.dataset.font || style.fontFamily || 'Georgia, serif'}`;
            const lineHeight = fontPx * 1.05;
            const maxLineWidth = box.width * (Number(layer.dataset.width || 78) / 100);
            const maxTextHeight = box.height * (Number(layer.dataset.height || 34) / 100) * .86;
            const wrappedLines = [];
            text.split('\n').forEach((line) => {
              const words = line.split(/\s+/).filter(Boolean);
              if (!words.length) {
                wrappedLines.push('');
                return;
              }
              let currentLine = '';
              words.forEach((word) => {
                const testLine = currentLine ? `${currentLine} ${word}` : word;
                if (ctx.measureText(testLine).width > maxLineWidth && currentLine) {
                  wrappedLines.push(currentLine);
                  currentLine = word;
                } else {
                  currentLine = testLine;
                }
              });
              wrappedLines.push(currentLine);
            });
            const measureGlyphLayout = (line) => {
              const glyphs = Array.from(line);
              const spacingPercent = Number.parseFloat(layer.dataset.textLetterSpacing || '0');
              const spacingPx = fontPx * (Number.isFinite(spacingPercent) ? spacingPercent / 100 : 0);
              const positions = [];
              let cursor = 0;
              let prefix = '';
              glyphs.forEach((glyph, index) => {
                const previousWidth = ctx.measureText(prefix).width;
                prefix += glyph;
                const nextWidth = ctx.measureText(prefix).width;
                const advance = Math.max(1, nextWidth - previousWidth);
                const left = cursor;
                const right = left + advance;
                positions.push({ left, right, advance });
                cursor = right + (index < glyphs.length - 1 ? spacingPx : 0);
              });
              return { glyphs, positions, rawWidth: Math.max(1, cursor) };
            };
            const uploadedFrameProfile = layer.dataset.textFrame ? await analyzeTextFrame(layer.dataset.textFrame) : null;
            const drawStyledGlyph = (drawingContext, glyph, xOffset, yOffset, glyphWidth, styleName, config, baseColor, outlineWidth, fontPx, maxWidth = undefined) => {
              drawingContext.save();
              drawingContext.lineJoin = 'round';
              drawingContext.miterLimit = 2;
              drawingContext.strokeStyle = 'rgba(0,0,0,.78)';
              drawingContext.lineWidth = outlineWidth * 2.4;
              drawingContext.strokeText(glyph, xOffset + fontPx * .055, yOffset + fontPx * .065, maxWidth);
              drawingContext.strokeStyle = config.borderColor || '#ffffff';
              drawingContext.lineWidth = outlineWidth * 1.35;
              drawingContext.strokeText(glyph, xOffset, yOffset, maxWidth);
              if (styleName === 'gold' || styleName === 'bronze') {
                const gradient = drawingContext.createLinearGradient(xOffset - glyphWidth / 2, yOffset - fontPx * .62, xOffset + glyphWidth / 2, yOffset + fontPx * .62);
                gradient.addColorStop(0, '#8e3508');
                gradient.addColorStop(.2, '#df7414');
                gradient.addColorStop(.43, '#ffbd32');
                gradient.addColorStop(.64, '#fff335');
                gradient.addColorStop(.82, '#e78315');
                gradient.addColorStop(1, '#ffcf35');
                drawingContext.fillStyle = gradient;
              } else if (styleName === 'pink') {
                const gradient = drawingContext.createLinearGradient(xOffset - glyphWidth / 2, yOffset - fontPx * .62, xOffset + glyphWidth / 2, yOffset + fontPx * .62);
                gradient.addColorStop(0, '#180629');
                gradient.addColorStop(.23, '#6e087f');
                gradient.addColorStop(.52, '#ff20d8');
                gradient.addColorStop(.73, '#b111c3');
                gradient.addColorStop(1, '#370348');
                drawingContext.fillStyle = gradient;
              } else if (styleName === 'galaxy') {
                const gradient = drawingContext.createLinearGradient(xOffset - glyphWidth / 2, yOffset - fontPx * .62, xOffset + glyphWidth / 2, yOffset + fontPx * .62);
                gradient.addColorStop(0, '#ff32ee');
                gradient.addColorStop(.24, '#c52cff');
                gradient.addColorStop(.58, '#6573ff');
                gradient.addColorStop(1, '#19e4ff');
                drawingContext.fillStyle = gradient;
              } else if (styleName === 'silver') {
                const gradient = drawingContext.createLinearGradient(0, yOffset - fontPx * .58, 0, yOffset + fontPx * .58);
                gradient.addColorStop(0, '#ffffff');
                gradient.addColorStop(.45, '#8a8a8a');
                gradient.addColorStop(1, '#f2f2f2');
                drawingContext.fillStyle = gradient;
              } else {
                drawingContext.fillStyle = baseColor;
              }
              drawingContext.fillText(glyph, xOffset, yOffset, maxWidth);
              drawingContext.globalAlpha = .58;
              drawingContext.strokeStyle = 'rgba(255,255,255,.92)';
              drawingContext.lineWidth = Math.max(1, outlineWidth * .24);
              drawingContext.strokeText(glyph, xOffset, yOffset - fontPx * .025, maxWidth);
              drawingContext.restore();
            };

            const drawFrameWarpedStyledText = (line, lineIndex, styleName, config, baseColor, outlineWidth) => {
              if (!line || !uploadedFrameProfile) return false;
              const { glyphs, positions, rawWidth } = measureGlyphLayout(line);
              const rowHeight = maxTextHeight / Math.max(1, wrappedLines.length);
              const rowCenter = (lineIndex - ((wrappedLines.length - 1) / 2)) * rowHeight;
              const frameInset = .04;
              const usableFrameWidth = 1 - frameInset * 2;
              glyphs.forEach((glyph, index) => {
                if (!glyph.trim()) return;
                const { left, advance: glyphAdvance } = positions[index];
                const glyphInkWidth = Math.max(1, ctx.measureText(glyph).width);
                const padding = Math.max(8, Math.ceil(fontPx * .24 + outlineWidth * 3));
                const sourceCanvas = document.createElement('canvas');
                sourceCanvas.width = Math.max(8, Math.ceil(glyphInkWidth + padding * 2));
                sourceCanvas.height = Math.max(8, Math.ceil(fontPx * 2.2 + padding * 2));
                const sourceContext = sourceCanvas.getContext('2d');
                sourceContext.clearRect(0, 0, sourceCanvas.width, sourceCanvas.height);
                sourceContext.textAlign = 'center';
                sourceContext.textBaseline = 'middle';
                sourceContext.font = ctx.font;
                drawStyledGlyph(
                  sourceContext,
                  glyph,
                  sourceCanvas.width / 2,
                  sourceCanvas.height / 2,
                  glyphInkWidth,
                  styleName,
                  config,
                  baseColor,
                  outlineWidth,
                  fontPx
                );
                const croppedGlyph = cropTransparentCanvas(sourceCanvas);
                const glyphStart = frameInset + (left / rawWidth) * usableFrameWidth;
                const glyphEnd = frameInset + ((left + glyphAdvance) / rawWidth) * usableFrameWidth;
                drawCanvasThroughTextFrame(
                  ctx,
                  croppedGlyph,
                  uploadedFrameProfile,
                  maxLineWidth,
                  rowHeight * .96,
                  rowCenter,
                  glyphStart,
                  glyphEnd
                );
              });
              return true;
            };

            const drawWarpedStyledText = (line, yOffset, styleName, config, baseColor, outlineWidth) => {
              if (!line) return;
              const { glyphs, positions, rawWidth } = measureGlyphLayout(line);
              const fitScaleX = maxLineWidth / Math.max(1, rawWidth);
              const fitScaleY = Math.min(1, maxTextHeight / Math.max(1, wrappedLines.length * lineHeight * 1.25));
              glyphs.forEach((glyph, index) => {
                const { left, right, advance: glyphWidth } = positions[index];
                const centerX = ((left + right) / 2 - rawWidth / 2) * fitScaleX;
                const t = glyphs.length <= 1 ? 0 : (index / (glyphs.length - 1)) * 2 - 1;
                const centerStrength = 1 - Math.min(1, Math.abs(t));
                let scaleX = fitScaleX;
                let scaleY = fitScaleY;
                let drawY = yOffset;
                let rotateGlyph = 0;
                if (config.warp === 'bulge') {
                  // Gold reference: large/high center, smaller lower ends.
                  scaleY *= .68 + centerStrength * .48;
                  scaleX *= .94 + centerStrength * .08;
                  drawY += Math.abs(t) * fontPx * .105;
                  rotateGlyph = t * .035;
                } else if (config.warp === 'arch') {
                  // Pink/Galaxy reference: a continuous arch with curved ends.
                  scaleY *= .9 + centerStrength * .12;
                  drawY += (t * t) * fontPx * .18 - fontPx * .11;
                  rotateGlyph = t * .055;
                }
                ctx.save();
                ctx.translate(centerX, drawY);
                ctx.rotate(rotateGlyph);
                ctx.scale(scaleX, scaleY);
                drawStyledGlyph(ctx, glyph, 0, 0, glyphWidth, styleName, config, baseColor, outlineWidth / Math.max(.05, scaleX), fontPx);
                ctx.restore();
              });
            };

            const drawStyledText = (line, yOffset, lineIndex) => {
              const styleName = layer.dataset.textStyle || '';
              const baseColor = layer.dataset.color || colorInput?.value || '#000000';
              if (!styleName) {
                const rawWidth = Math.max(1, ctx.measureText(line).width);
                const fitX = maxLineWidth / rawWidth;
                const fitY = Math.min(1, maxTextHeight / Math.max(1, wrappedLines.length * lineHeight));
                ctx.save();
                ctx.scale(fitX, fitY);
                if (Number(layer.dataset.borderWidth || 0) > 0) ctx.strokeText(line, 0, yOffset);
                ctx.fillText(line, 0, yOffset);
                ctx.restore();
                return;
              }
              const config = textStyleConfig(styleName, baseColor);
              const outlineWidth = Math.max(ctx.lineWidth, fontPx * .045);
              if (drawFrameWarpedStyledText(line, lineIndex, styleName, config, baseColor, outlineWidth)) {
                return;
              }
              if (config.warp === 'bulge' || config.warp === 'arch') {
                drawWarpedStyledText(line, yOffset, styleName, config, baseColor, outlineWidth);
                return;
              }
              const rawWidth = Math.max(1, ctx.measureText(line).width);
              const fitX = maxLineWidth / rawWidth;
              const fitY = Math.min(1, maxTextHeight / Math.max(1, wrappedLines.length * lineHeight * 1.15));
              ctx.save();
              ctx.scale(fitX, fitY);
              drawStyledGlyph(ctx, line, 0, yOffset, rawWidth, styleName, config, baseColor, outlineWidth / Math.max(.05, fitX), fontPx);
              ctx.restore();
            };
            wrappedLines.forEach((line, index) => {
              const yOffset = (index - ((wrappedLines.length - 1) / 2)) * lineHeight;
              drawStyledText(line, yOffset, index);
            });
          } else {
            const img = layer.querySelector('.designer-layer-content img');
            if (img?.src) {
              const layerImage = await loadCanvasImage(img.src);
              const printImage = prepareImageLayerForPrint(layerImage);
              const surfaceScale = size / Math.max(1, surfaceRect.width);
              const naturalWidth = layerImage.naturalWidth || printImage.width || 1;
              const naturalHeight = layerImage.naturalHeight || printImage.height || 1;
              const boxWidth = productionMode
                ? box.width * (Number(layer.dataset.width || 50) / 100) * layerScale
                : layerRect.width * surfaceScale;
              const boxHeight = productionMode
                ? box.height * (Number(layer.dataset.height || 34) / 100) * layerScale
                : layerRect.height * surfaceScale;
              const ratio = Math.min(boxWidth / naturalWidth, boxHeight / naturalHeight);
              const width = naturalWidth * ratio;
              const height = naturalHeight * ratio;
              ctx.drawImage(printImage, -width / 2, -height / 2, width, height);
            }
          }
          const borderWidth = Number(layer.dataset.borderWidth || 0);
          if (borderWidth > 0 && layer.dataset.type !== 'text') {
            const surfaceScale = size / Math.max(1, surfaceRect.width);
            const rectWidth = productionMode
              ? box.width * (Number(layer.dataset.width || 50) / 100) * layerScale
              : layerRect.width * surfaceScale;
            const rectHeight = productionMode
              ? box.height * (Number(layer.dataset.height || 34) / 100) * layerScale
              : layerRect.height * surfaceScale;
            ctx.strokeStyle = layer.dataset.borderColor || '#000000';
            ctx.lineWidth = borderWidth * (productionMode ? 4 : surfaceScale);
            ctx.strokeRect(-rectWidth / 2, -rectHeight / 2, rectWidth, rectHeight);
          }
          ctx.restore();
        };

        const layers = getLayers().reverse();
        const productionArea = {
          x: (area.x / size) * productionCanvas.width,
          y: (area.y / size) * productionCanvas.height,
          width: (area.width / size) * productionCanvas.width,
          height: (area.height / size) * productionCanvas.height
        };
        for (const layer of layers) {
          await drawLayer(previewDesign, layer, false);
          if (displayDesign && layer !== originalCustomerLayer) {
            if (foreground && layerStackRank(layer) < layerStackRank(originalCustomerLayer)) {
              await drawLayer(foreground, layer, false);
            } else {
              await drawLayer(displayDesign, layer, false);
            }
          }
          await drawLayer(production, layer, true);
        }
        applyFabricBlend(previewDesign, size);
        preview.drawImage(previewDesignCanvas, 0, 0);
        if (display && displayDesign && displayDesignCanvas) {
          applyFabricBlend(displayDesign, size);
          display.drawImage(displayDesignCanvas, 0, 0);
        }
        if (foreground) applyFabricBlend(foreground, size);

        const previewDataUrl = previewCanvas.toDataURL('image/png');
        const displayPreviewDataUrl = displayCanvas ? displayCanvas.toDataURL('image/png') : previewDataUrl;
        const foregroundDataUrl = foregroundCanvas ? foregroundCanvas.toDataURL('image/png') : '';
        const productionDataUrl = productionCanvas.toDataURL('image/png');
        if (renderRevision !== editRevision) return null;
        lastRender = { previewDataUrl, productionDataUrl, previewUrl: '', productionUrl: '' };
        /* Render the lower layers into the mockup, preserve the original customer
           image in the middle, and render text into a transparent top layer. */
        if (productImage) {
          productImage.src = displayPreviewDataUrl;
          productImage.srcset = '';
        }
        showOriginalUploadRenderOverlay();
        showRenderedTextForeground(foregroundDataUrl);
        surface.classList.add('is-rendered');
        editorPanel?.classList.add('is-collapsed');
        if (editorExpand) editorExpand.hidden = true;
        if (renderButton) renderButton.textContent = 'Preview ready';
        if (finalPreviewImage) finalPreviewImage.src = previewDataUrl;
        if (finalPreview) finalPreview.hidden = true;
        let previewUrl = '';
        let productionUrl = '';
        if (upload && canRemoteRender) {
          try {
            setDesignerStatus('Sending design to professional render server...');
            const remote = await renderWithRemoteService({ previewDataUrl, productionDataUrl });
            previewUrl = remote.preview_url || remote.previewUrl || '';
            productionUrl = remote.print_url || remote.production_url || remote.productionUrl || '';
          } catch (error) {
            console.warn(error);
          }
        }
        if (!previewUrl && upload && canUploadToCloud) {
          const idBase = `anduvu-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          previewUrl = await uploadDataUrlToCloudinary(previewDataUrl, 'anduvu-customizer/previews', `${idBase}-preview`);
          productionUrl = await uploadDataUrlToCloudinary(productionDataUrl, 'anduvu-customizer/print-files', `${idBase}-print`);
        }
        if (previewProperty) previewProperty.value = previewUrl || previewDataUrl;
        if (productionProperty) productionProperty.value = productionUrl || productionDataUrl;
        if (finalPreviewUrl) {
          finalPreviewUrl.href = previewUrl || previewDataUrl;
          finalPreviewUrl.hidden = false;
        }
        lastRender = { previewDataUrl, productionDataUrl, previewUrl, productionUrl };
        setDesignerStatus(previewUrl
          ? 'Preview ready. Design files are saved with this cart item.'
          : 'Preview ready.'
        );
        updateDesignerProperties();
        const currentData = dataProperty?.value ? JSON.parse(dataProperty.value) : {};
        if (dataProperty) {
          dataProperty.value = JSON.stringify({
            ...currentData,
            previewUrl: previewUrl || 'local-data-url',
            productionUrl: productionUrl || 'local-data-url'
          });
        }
        return lastRender;
      } catch {
        if (lastRender?.previewDataUrl && previewProperty) previewProperty.value = lastRender.previewDataUrl;
        if (lastRender?.productionDataUrl && productionProperty) productionProperty.value = lastRender.productionDataUrl;
        setDesignerStatus('Preview ready.');
        return lastRender;
      } finally {
        setRenderingState(false);
      }
    };

    const scheduleAutoRender = () => {
      window.clearTimeout(autoRenderTimer);
      autoRenderTimer = window.setTimeout(() => {
        if (!section.isConnected || !getLayers().length) return;
        renderDesigner({ upload: canUploadDesignFiles }).catch(() => {});
      }, 420);
    };

    const renderNow = () => {
      window.clearTimeout(autoRenderTimer);
      autoRenderTimer = null;
      if (!section.isConnected || !getLayers().length) return Promise.resolve(null);
      const requestedRevision = editRevision;
      if (immediateRenderPromise && immediateRenderRevision === requestedRevision) return immediateRenderPromise;
      immediateRenderRevision = requestedRevision;
      const request = renderDesigner({ upload: canUploadDesignFiles }).catch(() => null);
      immediateRenderPromise = request;
      request.finally(() => {
        if (immediateRenderPromise !== request) return;
        immediateRenderPromise = null;
        immediateRenderRevision = -1;
      });
      return request;
    };

    section._anduvuSetMockup = (src, { render = true } = {}) => {
      const nextSrc = String(src || '').trim();
      if (!nextSrc) return;
      enterEditMode();
      baseProductImageSrc = nextSrc;
      section.dataset.activeMockupSrc = nextSrc;
      const selectedProduct = productSelect?.options[productSelect.selectedIndex];
      if (selectedProduct) selectedProduct.dataset.productImage = nextSrc;
      if (productImage) {
        productImage.crossOrigin = 'anonymous';
        productImage.addEventListener('load', syncUsableArea, { once: true });
        productImage.src = nextSrc;
        productImage.srcset = '';
      }
      updateDesignerProperties();
      if (render && getLayers().length) {
        window.requestAnimationFrame(() => renderNow());
      }
    };

    productSelect?.addEventListener('change', syncProduct);
    sizeSelect?.addEventListener('change', () => {
      enterEditMode();
      setVariantForSize();
      updateDesignerProperties();
    });
    shirtColorSelect?.addEventListener('change', () => {
      enterEditMode();
      syncBlankPatch();
      updateDesignerProperties();
    });
    quantityInput?.addEventListener('input', updateTotals);
    fontSelect?.addEventListener('change', () => {
      if (activeLayer?.dataset.type === 'text') {
        delete activeLayer.dataset.textFontUrl;
        activeLayer._anduvuFontReady = null;
      }
      updateActiveTextStyle();
    });
    colorInput?.addEventListener('input', () => {
      updateActiveTextStyle();
    });
    textInput?.addEventListener('input', updateActiveTextStyle);
    customerTextInput?.addEventListener('focus', () => {
      textEditing = true;
      enterEditMode();
    });
    customerTextInput?.addEventListener('input', () => {
      enterEditMode();
      const next = uppercaseDesignText(customerTextInput.value);
      if (customerTextInput.value !== next) customerTextInput.value = next;
      if (textInput) textInput.value = next;
      const targetTextLayer = findTextLayerByRole('top') || surface.querySelector('.designer-layer[data-type="text"]');
      if (targetTextLayer) {
        targetTextLayer.dataset.text = next;
        const content = targetTextLayer.querySelector('.designer-layer-content');
        if (content) content.textContent = next;
        queueTextFit(targetTextLayer);
        updateDesignerProperties();
      } else {
        applyText({ value: next, role: 'top' });
      }
    });
    customerTextInput?.addEventListener('blur', () => {
      if (!textEditing) return;
      textEditing = false;
      window.queueMicrotask(() => {
        if (customerImageEditing || dragState || resizeState || rotateState) return;
        renderNow();
      });
    });
    section.querySelectorAll('[data-custom-type-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        if (radio.value === 'Text') {
          if (activeLayer?.dataset.type === 'text') {
            selectLayer(activeLayer);
          } else {
            applyText();
          }
        }
        if (radio.value === 'Image') {
          if (imageModal) imageModal.hidden = false;
        }
      });
    });
    scaleInput?.addEventListener('input', () => {
      if (!activeLayer) return;
      enterEditMode();
      activeLayer.dataset.scale = scaleInput.value;
      updateLayerTransform(activeLayer);
      updateDesignerProperties();
    });
    rotateInput?.addEventListener('input', () => {
      if (!activeLayer) return;
      enterEditMode();
      activeLayer.dataset.rotate = rotateInput.value;
      updateLayerTransform(activeLayer);
      updateDesignerProperties();
    });
    fontSizeInput?.addEventListener('input', () => {
      if (!activeLayer) return;
      enterEditMode();
      if (activeLayer.dataset.type === 'text') {
        activeLayer.style.fontSize = `${fontSizeInput.value}px`;
        activeLayer.dataset.fontSize = fontSizeInput.value;
      }
      updateDesignerProperties();
    });
    widthInput?.addEventListener('input', () => {
      if (!activeLayer) return;
      enterEditMode();
      activeLayer.dataset.width = widthInput.value;
      updateLayerTransform(activeLayer);
      updateDesignerProperties();
    });
    borderWidthInput?.addEventListener('input', () => {
      if (!activeLayer) return;
      enterEditMode();
      activeLayer.dataset.borderWidth = borderWidthInput.value || '0';
      updateLayerTransform(activeLayer);
      updateDesignerProperties();
    });
    borderColorInput?.addEventListener('input', () => {
      if (!activeLayer) return;
      enterEditMode();
      activeLayer.dataset.borderColor = borderColorInput.value || '#000000';
      updateLayerTransform(activeLayer);
      updateDesignerProperties();
    });
    boldButton?.addEventListener('click', () => {
      const pressed = boldButton.getAttribute('aria-pressed') === 'true';
      boldButton.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      updateActiveTextStyle();
    });
    italicButton?.addEventListener('click', () => {
      const pressed = italicButton.getAttribute('aria-pressed') === 'true';
      italicButton.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      updateActiveTextStyle();
    });
    applyButton?.addEventListener('click', async () => {
      const mode = section.querySelector('[data-custom-type-radio]:checked')?.value || 'Text';
      if (mode === 'Text' && activeLayer?.dataset.type === 'text') {
        updateActiveTextStyle();
      } else if (!activeLayer && mode === 'Text') {
        applyText({ value: 'YOUR DESIGN HERE' });
      }
      await renderDesigner({ upload: canUploadDesignFiles });
    });
    addLayerButton?.addEventListener('click', () => {
      if (newLayerMenu) newLayerMenu.hidden = !newLayerMenu.hidden;
    });
    addTextButton?.addEventListener('click', () => {
      if (newLayerMenu) newLayerMenu.hidden = true;
      applyText({ value: 'YOUR DESIGN HERE' });
      const content = activeLayer?.querySelector('.designer-layer-content');
      content?.focus();
      if (document.createRange && window.getSelection && content) {
        const range = document.createRange();
        range.selectNodeContents(content);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });
    addImageButton?.addEventListener('click', () => {
      if (newLayerMenu) newLayerMenu.hidden = true;
      if (imageModal) imageModal.hidden = false;
    });
    imageLibraryButtons.forEach((button) => button.addEventListener('click', () => {
      if (imageModal) imageModal.hidden = false;
    }));
    uploadTriggers.forEach((button) => button.addEventListener('click', () => uploadInput?.click()));
    surface?.addEventListener('click', (event) => {
      if (event.target.closest('button, input, select, textarea, a')) return;
      if (surface.classList.contains('is-rendered')) {
        event.stopPropagation();
        enterEditMode();
        const customerLayer = surface.querySelector('[data-customer-upload="true"]');
        if (customerLayer) {
          customerImageEditing = true;
          selectLayer(customerLayer);
        }
        return;
      }
      if (event.target.closest('[data-customer-upload="true"]')) return;
      if (!customerImageEditing) return;
      event.stopPropagation();
      customerImageEditing = false;
      renderNow();
    });
    document.addEventListener('click', (event) => {
      if (textEditing && !event.target.closest('[data-designer-customer-text]')) {
        textEditing = false;
        customerTextInput?.blur();
        if (!customerImageEditing) renderNow();
      }
      if (!customerImageEditing || !section.isConnected) return;
      if (event.target.closest('[data-customer-upload="true"]')) return;
      customerImageEditing = false;
      renderNow();
    });
    imageModalClose?.addEventListener('click', () => {
      if (imageModal) imageModal.hidden = true;
    });
    imageModal?.addEventListener('click', (event) => {
      if (event.target === imageModal) imageModal.hidden = true;
    });
    section.querySelectorAll('[data-template-image]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-template-image]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        applyImageSrc(button.dataset.templateImage, button.querySelector('img')?.alt || 'Template image');
        if (imageModal) imageModal.hidden = true;
      });
    });
    bgPresetButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (event.target.closest('[data-bg-remove]')) {
          event.preventDefault();
          event.stopPropagation();
          if (bgEnabledInput) bgEnabledInput.checked = false;
          button.closest('[data-preset-section]')?.classList.add('is-disabled');
          bgPresetButtons.forEach((item) => item.classList.remove('is-selected'));
          ensureBackgroundLayer('none');
          scheduleAutoRender();
          return;
        }
        if (bgEnabledInput) {
          bgEnabledInput.checked = true;
          bgEnabledInput.closest('[data-preset-section]')?.classList.remove('is-disabled');
        }
        bgPresetButtons.forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        ensureBackgroundLayer(button.dataset.bgPreset || 'sunset', button.dataset.bgImage || '');
        scheduleAutoRender();
      });
    });
    textPresetButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetRole = button.dataset.textTarget || '';
        const enabledInput = targetRole ? section.querySelector(`[data-text-enabled="${targetRole}"]`) : null;
        if (enabledInput) {
          enabledInput.checked = true;
          enabledInput.closest('[data-preset-section]')?.classList.remove('is-disabled');
        }
        const group = button.closest('[data-text-preset-group]');
        group?.querySelectorAll('[data-text-preset]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        applyTextPreset(
          button.dataset.textPreset || '#000000',
          button.dataset.textStyle || '',
          button.dataset.textTarget || '',
          button.dataset.textFrame || '',
          button.dataset.textFrameAspect || '',
          button.dataset.textLetterSpacing || '0',
          button.dataset.textFontUrl || ''
        );
        scheduleAutoRender();
      });
    });
    bgEnabledInput?.addEventListener('change', () => {
      bgEnabledInput.closest('[data-preset-section]')?.classList.toggle('is-disabled', !bgEnabledInput.checked);
      if (!bgEnabledInput.checked) {
        bgPresetButtons.forEach((item) => item.classList.remove('is-selected'));
        ensureBackgroundLayer('none');
      } else {
        const selected = Array.from(bgPresetButtons).find((button) => button.classList.contains('is-selected')) || bgPresetButtons[0];
        selected?.classList.add('is-selected');
        ensureBackgroundLayer(selected?.dataset.bgPreset || 'cloud-galaxy', selected?.dataset.bgImage || '');
      }
      scheduleAutoRender();
    });
    bgUploadTrigger?.addEventListener('click', () => bgUploadInput?.click());
    bgUploadInput?.addEventListener('change', () => {
      const file = bgUploadInput.files?.[0];
      if (!file) return;
      const src = URL.createObjectURL(file);
      if (bgEnabledInput) {
        bgEnabledInput.checked = true;
        bgEnabledInput.closest('[data-preset-section]')?.classList.remove('is-disabled');
      }
      bgPresetButtons.forEach((item) => item.classList.remove('is-selected'));
      ensureBackgroundLayer('custom-upload', src);
      if (bgUploadInput) bgUploadInput.value = '';
      scheduleAutoRender();
    });
    textEnabledInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const role = input.dataset.textEnabled;
        input.closest('[data-preset-section]')?.classList.toggle('is-disabled', !input.checked);
        if (!input.checked) {
          findTextLayerByRole(role)?.remove();
          activeLayer = getLayers()[0] || null;
          updateLayerStack();
          updateLayerPanel();
          updateDesignerProperties();
          scheduleAutoRender();
          return;
        }
        const group = input.closest('[data-preset-section]')?.querySelector('[data-text-preset-group]');
        const selected = group?.querySelector('[data-text-preset].is-selected') || group?.querySelector('[data-text-preset]');
        if (selected) {
          selected.classList.add('is-selected');
          applyTextPreset(
            selected.dataset.textPreset || '#000000',
            selected.dataset.textStyle || '',
            selected.dataset.textTarget || role,
            selected.dataset.textFrame || '',
            selected.dataset.textFrameAspect || '',
            selected.dataset.textLetterSpacing || '0',
            selected.dataset.textFontUrl || ''
          );
        } else {
          applyText({ value: 'CUSTOM', role });
        }
        scheduleAutoRender();
      });
    });
    uploadInput?.addEventListener('change', () => {
      const uploadedLayer = applyImageFile(uploadInput.files?.[0]);
      if (imageModal) imageModal.hidden = true;
      if (!uploadedLayer) return;
      customerImageEditing = false;
      const uploadedImage = uploadedLayer.querySelector('.designer-layer-content img');
      const renderUploadedImage = () => {
        window.requestAnimationFrame(() => renderNow());
      };
      if (uploadedImage?.complete && uploadedImage.naturalWidth) {
        renderUploadedImage();
      } else {
        uploadedImage?.addEventListener('load', renderUploadedImage, { once: true });
      }
    });
    editorClose?.addEventListener('click', () => {
      editorPanel?.classList.add('is-collapsed');
      if (editorExpand) editorExpand.hidden = false;
    });
    editorExpand?.addEventListener('click', () => {
      editorPanel?.classList.remove('is-collapsed');
      editorExpand.hidden = true;
    });
    deleteButton?.addEventListener('click', () => {
      enterEditMode();
      if (activeLayer?.dataset.customerUpload === 'true') clearOriginalCustomerUpload();
      activeLayer?.remove();
      activeLayer = getLayers()[0] || null;
      updateLayerStack();
      if (activeLayer) selectLayer(activeLayer);
      updateLayerPanel();
      updateDesignerProperties();
    });
    resetButton?.addEventListener('click', () => {
      enterEditMode();
      clearDesignLayers();
      if (finalPreview) finalPreview.hidden = true;
      renderedPreviews.length = 0;
      renderPreviewThumbs();
      didRenderDefaultTemplate = true;
    });
    renderButton?.addEventListener('click', async () => {
      if (surface?.classList.contains('is-rendered')) {
        enterEditMode();
        editorPanel?.classList.remove('is-collapsed');
        if (editorExpand) editorExpand.hidden = true;
        return;
      }
      const render = await renderDesigner({ upload: canUploadDesignFiles });
      addRenderedPreview(render);
    });
    section.addEventListener('anduvu:force-render', async (event) => {
      surface.classList.remove('is-rendered');
      const render = await renderDesigner({ upload: Boolean(event.detail?.upload) && canUploadDesignFiles });
      addRenderedPreview(render);
    });
    section._anduvuForceRender = async ({ upload = false } = {}) => {
      surface.classList.remove('is-rendered');
      const render = await renderDesigner({ upload: Boolean(upload) && canUploadDesignFiles });
      addRenderedPreview(render);
      return render;
    };
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitter = event.submitter;
      const isBuyNow = submitter?.name === 'checkout';
      const button = submitter?.matches('button') ? submitter : form.querySelector('.product-atc');
      const label = button?.querySelector('span');
      const originalLabel = label?.textContent || (isBuyNow ? 'Buy now' : 'Add custom product to cart');
      button?.classList.add('is-loading');
      if (button) button.disabled = true;
      if (label) label.textContent = isBuyNow ? 'Preparing checkout...' : 'Adding...';
      try {
        if (!renderedPreviews.length) {
          const render = await renderDesigner({ upload: canUploadDesignFiles });
          addRenderedPreview(render);
        }
        const selected = selectedPreviewItems();
        if (!selected.length) {
          throw new Error('Select at least one preview image before adding to cart.');
        }
        setVariantForSize();
        const variantId = Number(variantInput.value);
        if (!variantId) {
          throw new Error('Please choose a product before adding to cart.');
        }
        const quantity = Math.max(1, Number(quantityInput?.value || 1));
        const baseData = dataProperty?.value ? JSON.parse(dataProperty.value) : {};
        const customVariants = parseVariants();
        const customCandidateIds = [
          variantId,
          ...customVariants.map((variant) => variant.id),
          cartFallbackVariantId
        ].filter(Boolean).map(String).filter((value, index, list) => list.indexOf(value) === index);
        for (const item of selected) {
          const payload = {
            quantity,
            properties: {
              'Custom Design': 'Yes',
              'Product Preview': item.previewUrl || item.previewDataUrl,
              'Production Print File': item.productionUrl || item.productionDataUrl,
              'Design Data': item.designData || JSON.stringify(baseData),
              'Custom Text': textProperty?.value || '',
              'Shirt Color': shirtColorSelect?.value || '',
              'Selected Size': sizeSelect?.value || '',
              'Instructions': notesInput?.value || '',
              'AI Render Prompt': aiPromptProperty?.value || '',
              'Preview Number': String(item.index)
            }
          };
          let response = null;
          let lastError = null;
          for (const id of customCandidateIds) {
            const originalUpload = section._anduvuOriginalUploadFile;
            const hasOriginalUpload = originalUpload instanceof File && originalUpload.size > 0;
            const requestOptions = hasOriginalUpload
              ? (() => {
                  const formData = new FormData();
                  formData.set('id', String(id));
                  formData.set('quantity', String(quantity));
                  Object.entries(payload.properties).forEach(([key, value]) => {
                    formData.set(`properties[${key}]`, String(value || ''));
                  });
                  formData.set('properties[Original Uploaded Image]', originalUpload);
                  return {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: formData
                  };
                })()
              : {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ ...payload, id: Number(id) || id })
                };
            response = await fetch(`${shopRoot}cart/add.js`, {
              ...requestOptions
            });
            if (response.ok) break;
            lastError = await response.json().catch(() => ({}));
          }
          if (!response?.ok) {
            throw new Error(lastError?.description || lastError?.message || 'Could not add this custom product.');
          }
        }
        if (isBuyNow) {
          window.location.href = `${shopRoot}checkout`;
          return;
        }
        await fetchCart();
        openCartDrawer();
        setDesignerStatus('Custom product added to cart.');
      } catch (error) {
        const message = error.message || 'Could not add this custom product. Please check the selected product.';
        setDesignerStatus(/sold\s*out|already\s*sold|unavailable/i.test(message) ? '' : message);
      } finally {
        button?.classList.remove('is-loading');
        if (button) button.disabled = false;
        if (label) label.textContent = originalLabel;
      }
    });

    syncProduct();
    syncBlankPatch();
    syncUsableArea();
    setDesignerStatus(canUploadToCloud
      ? 'Edit layers directly on the product image, then apply preview before adding to cart.'
      : 'Edit layers directly on the product image, then apply preview before adding to cart.'
    );
  });
})();
